<!--
 * @Author: your name
 * @Date: 2021-07-09 14:22:41
 * @LastEditTime: 2022-04-28 10:27:47
 * @LastEditors: Please set LastEditors
 * @Description: In User Settings Edit
 * @FilePath: \vindel-map-pc\src\App.vue
-->
<template>
    <!-- <div class="exam" id="exam"> -->
    <div class="exam" id="exam" @click="enterFullScreen">
        <el-dialog
            title="语音题作答"
            :visible.sync="voiceDialogVisible"
            :show-close="false"
            :modal-append-to-body='false'
            :close-on-click-modal='false'
            width="480px"
            height:="550px"
            :before-close="handleClose">
            <div style="margin-bottom:12px;">试题内容</div>
            <div style="display: flex;justify-content:flex-start;" class="voice-content" v-html="voiceDetail.questionText"></div>
            <div style="margin-top:30px;margin-bottom:12px;">作答内容</div>
            <div class="voice-answer" style="position: relative;">
                <span v-if="voiceDetail.recorder && voiceDetail.recorder.voiceTime">
                    <span v-if="voiceDetail.recorder.voiceTime > 59"> {{`0${(voiceDetail.recorder.voiceTime / 60).toFixed(0)}:${voiceDetail.recorder.voiceTime %60 > 9 ? voiceDetail.recorder.voiceTime%60 : `0${voiceDetail.recorder.voiceTime%60}`}`}} </span>
                    <span v-else>
                    {{ `00:${voiceDetail.recorder.voiceTime > 9 ? voiceDetail.recorder.voiceTime : `0${voiceDetail.recorder.voiceTime}`}`}}
                    </span>
                </span>
                <span v-else>暂无录音文件</span>
                <div  style="position: absolute;top: -50%;transform: translateY(100%);width: 100%;display: flex;justify-content:flex-start;margin-top: 16px;left: 16px;">
                    <img style="margin-right:8px;" @click.stop="playRecorder()"  v-if="(voiceDetail.voiceType == 'stop'&& voiceType == '' )||( voiceDetail.voiceType=='pause' &&  voiceType == '') || ( voiceDetail.voiceType=='pause' &&  voiceType == 'pause') || ( voiceDetail.voiceType=='pause' &&  voiceType == 'stop') || ( voiceDetail.voiceType== 'stop' &&  voiceType == 'pause')" src="../../assets/exam/voice/icon-play.png" alt="">
                    <img style="margin-right:8px;" v-if="(voiceDetail.voiceType == 'stop'&& voiceType == 'play') || (voiceDetail.voiceType=='pause'  && voiceType == 'play')" @click.stop="pausePlayRecorder()" src="../../assets/exam/voice/icon-pause.png" alt="">
                    <img style="margin-right:8px;" v-if="voiceDetail.voiceType == 'stop' || voiceDetail.voiceType=='pause' || voiceType=='pause'" @click.stop="stopPlayRecorder()" src="../../assets/exam/voice/icon-stop.png" alt="">
                </div>
            </div>
            <div  style="width: 100%;display: flex;justify-content:flex-start;margin-top: 16px;">
                <img class="voice-btn"  @click.stop="recorderStart" v-if="voiceDetail.voiceType == ''"  src="../../assets/exam/voice/paly.png" alt="">
                <!-- <img class="voice-btn"  src="../../assets/exam/voice/pause.png" alt="" @click.stop="pauseRecorder" v-if="voiceDetail.voiceType == 'play' || voiceDetail.voiceType == 'continuePlay'"> -->
                <!-- <img class="voice-btn"  src="../../assets/exam/voice/continue.png"  alt=""  @click.stop="resumeRecorder"  v-if="voiceDetail.voiceType=='pause'"> -->
                <img class="voice-btn"  src="../../assets/exam/voice/accomplish.png" alt=""  @click.stop="recorderStop" v-if="voiceDetail.voiceType == 'play' || voiceDetail.voiceType == 'continuePlay' || voiceDetail.voiceType=='pause'">
                <img class="voice-btn"  src="../../assets/exam/voice/replay.png" @click.stop="recorderStart" v-if="voiceDetail.voiceType == 'stop'" alt="">              
            </div>
           
            <div style="width: 100%;display: flex;justify-content: flex-end;margin-top: 16px;">
                <el-button  @click.stop="closeVoiceDialogVisible">关闭</el-button>
                <el-button type="primary" @click.stop="submitVoice">提交</el-button>
            </div>
        </el-dialog>
        <el-dialog
            title="保存试卷"
            :visible.sync="saveDialogVisible"
            :show-close="false"
            :modal-append-to-body='false'
            :close-on-click-modal='false'
            width="30%"
            :before-close="handleClose">
            <span v-if="unfinishedNum">您还有{{unfinishedNum}}题未完成,确定保存吗?</span>
            <div style="width: 100%;display: flex;justify-content: flex-end;margin-top: 8px;">
                <el-button  @click.stop="saveDialogVisible = false">取消</el-button>
                <el-button type="primary" @click.stop="showSaveModal">确定</el-button>
            </div>
        </el-dialog>
        <el-dialog
            title="提示"
            :visible.sync="noOperation"
            :show-close="false"
            :modal-append-to-body='false'
            :close-on-click-modal='false'
            width="30%"
            :before-close="handleClose">
            <span>
                {{`${cutdownNum}秒内无操作将强制交卷，如需继续作答，请任意操作鼠标键盘...`}}
            </span>
            <!-- <div style="width: 100%;display: flex;justify-content: flex-end;margin-top: 8px;">
                <el-button type="primary" @click.stop="noOperation = false">确定</el-button>
            </div> -->
        </el-dialog>
        <el-dialog
            title="提交试卷"
            :visible.sync="submitDialogVisible"
            :show-close="false"
            :modal-append-to-body='false'
            :close-on-click-modal='false'
             width="30%"
            :before-close="handleClose">
            <span v-if="unfinishedNum">您还有{{unfinishedNum}}题未完成,确定交卷吗?</span>
            <div style="width: 100%;display: flex;justify-content: flex-end;margin-top: 8px;">               
               <el-button   @click.stop="submitDialogVisible = false">取消</el-button>
               <el-button type="primary"  @click.stop="showSubmitModal">确定</el-button>
            </div>
        </el-dialog>
        <el-dialog
            title="考试暂停"
            :visible.sync="pauseDialogVisible"
            :show-close="false"
            :modal-append-to-body='false'
            :close-on-click-modal='false'
             width="30%"
            :before-close="handleClose">
            <div style="margin-bottom:16px;" v-if="isPauseText">消息通知:  {{isPauseText}}</div>
            <span>考试暂停中</span>
            <span slot="footer" class="dialog-footer" v-if="!isPause">
              <el-button type="primary" @click="continueExam">继续考试</el-button>
            </span>
        </el-dialog>
        <el-dialog
            custom-class="no-header-modal"
            :modal="false"
            title="试题检查"
            :visible.sync="dialogVisible"
            width="30%"
            :before-close="handleClose">
            <span>没做的试题有:{{unfinishedNum}}个,已在试题导航中显示,并且已经有{{isSignNum}}个试题已做标注.</span>
            <span slot="footer" class="dialog-footer">
              <el-button type="primary" @click.stop="dialogVisible = false">关闭</el-button>
            </span>
        </el-dialog>
        <el-dialog
            :show-close="true"
            :modal-append-to-body='false'
            :close-on-click-modal='false'
            custom-class="submit-modal"
            :visible.sync="submitFailDialogVisible"
            width="30%"
            >
            <img class="icon-left" src="../../assets/exam/notification.png" alt="">
            <img class="icon-right" src="../../assets/exam/Ball.png" alt="">
            <div>
                <div class="title">答案提交失败，请重新提交</div>
                <div class="tips">网络可能存在问题,请再次提交!</div>
                <div style="display:flex;width:75%;margin:auto;margin-top:32px">
                  <div class="submit-btn" style="width: 180px;height: 45px;"  @click.stop="closeSubmitFailDialogVisible">关闭提示</div>
                </div>     
            </div>         
        </el-dialog>
        <el-dialog
            :show-close="true"
            :modal-append-to-body='false'
            :close-on-click-modal='false'
            custom-class="submit-modal"
            :visible.sync="answerDialogVisible"
            width="30%"
            :before-close="closePage">
            <img class="icon-left" src="../../assets/exam/notification.png" alt="">
            <img class="icon-right" src="../../assets/exam/Ball.png" alt="">
            <div>
                <div class="title">答案提交成功</div>
                <div class="tips" v-if="canSeeGrade">本次考试客观题成绩为</div>
                <div class="score" v-if="canSeeGrade">{{gradeScore}}
                     <span style="font-size: 35px;font-weight: 400;text-align: left;color: #ff6c75;line-height: 41px;">分</span> 
                </div>
                <div style="display:flex;width:75%;margin:auto;margin-top:32px">
                  <div class="submit-btn" style="width: 180px;height: 45px;" v-if="isAllowViewPaperNow"  @click.stop="goAnswerPaper">查看答卷</div>
                  <div class="submit-btn"  style="width: 180px;height: 45px;color: #FFF;background-color: #909399;border-color: #909399;"  @click.stop="closePaper">关闭试卷</div>              
                </div>     
            </div>         
        </el-dialog>         
        <el-dialog
            :show-close="false"
            :modal-append-to-body='false'
            :close-on-click-modal='false'
            :custom-class="'off-face-modal'"
            :visible.sync="isBreakOffFace"
            width="30%"
            >         
            <div class="face-modal-content">
              <!-- <img
                class="left-top-icon"
                src="../../../assets/exam/left-head-icon.png"
                alt=""
              /> -->
              <div class="face-title">异常提醒</div>
              <div class="face-tips">系统检测到“辅助机位”当前已离线</div>
              <div class="face-tips">请检测其设备是否正常或重新扫描按提示进行架设</div>
              <div class="face-code" ref="qrCodeUrl"></div>
              <div class="code-tips success" v-if="isCheckFace">辅助机位开启成功</div>
              <div class="code-tips error" v-else>尚未开启辅助机位</div>
            </div>
        </el-dialog>       
        <div class="exam-header">            
            <div class="header-detail">
                <img src="../../assets/exam/Breadcrumb.png" alt="">
                <div class="paper-headr">
                    <div class="exam-center">考试中心</div>
                    <div class="paper-name">{{ detail.paperDetail.paperName }} {{!detail.exam.examDoModeCode?'':detail.exam.examDoModeCode == 'paper' ? '整卷模式' : '逐题模式' }}{{ `[${(detail.exam.examName||'')}]` }}
                    </div>
                    <div class="paper-message"> 
                        <span style="margin-right:18px;"><span class="label">共:</span> {{ `${detail.paperDetail.examPaper.questionNum}题` }} </span>
                        <span style="margin-right:18px;"><span class="label">满分:</span> {{ `${detail.paperDetail.examPaper.totalScore}分` }} </span>
                        <span ><span class="label">总时长:</span> {{examTime ? `${examTime}分钟`: ' 不限时'}}</span>
                    </div>
                </div>
            </div>
            <div class="headers-nav"  v-if="!isShowTop">
               <div class="normal">
                    <div class="user-detail">
                    <img v-if="imgUrl" :src="imgUrl" alt="">
                    <img
                      v-else-if="detail.userInfo.sex == 'female'"
                      class="userInfo-img"
                      src="../../assets/female.png"
                      alt=""
                    />
                    <img
                      v-else
                      class="userInfo-img"
                      src="../../assets/male.png"
                      alt=""
                    />
                    <div class="user-right">
                        <div class="user-name" v-if="detail.userInfo">{{detail.userInfo.name}}</div>
                        <div class="user-code" v-if="detail.userInfo">登录名:{{detail.userInfo.userName}}</div>
                    </div>
                </div>
                 <div class="font-select">
                    <div class="select-text">
                        文字大小调整
                    </div>
                    <div>
                        <el-slider
                        style="width:120px;"
                          v-model="fontValue"
                          :format-tooltip="formatTooltip"
                          :step="1"
                          :max="3"
                          @change="fontChange"
                          show-stops>
                        </el-slider>
                    </div>
                </div>
                <div class="nav-right">
                    <span v-if="isSave" class="showSave" :class="hidden&&'hidden'">保存成功</span>                
                    <div class="operate-btn" v-if="!isStop">
                        <div class="exam-btn" @click.stop="save('save')" style="margin-right:28px;">
                            <img src="../../assets/exam/btn-save.png" alt="">
                            <span>保存</span>
                        </div>
                        <div class="exam-btn"  @click.stop="checkQuestion" style="margin-right:28px;">
                            <img src="../../assets/exam/btn-check.png" alt="">
                            <span>检查</span>
                        </div>
                        <div class="exam-btn"  @click.stop="pause" style="margin-right:28px;" v-if="detail.exam.isOpenBook">
                            <img src="../../assets/exam/btn-pause.png" alt="">
                            <span>暂停</span>
                        </div>
                        <div  class="exam-btn"   @click.stop="save('submit')" v-if="!isStop">
                             <img src="../../assets/exam/btn-submit.png" alt="">
                            <span>交卷</span>
                        </div>                    
                    </div>
                </div>
               </div>
              
            </div>         
            <div class="headers-nav"  v-else style="width:100%;height:94px;box-shadow: 0px 2px 5px 0px rgba(0, 0, 0, 0.2);border-radius:0px;">
                <div class="small">
                    <div class="user-detail">
                        <div class="detail-top">
                            <div class="paper-name">
                               {{ detail.paperDetail.paperName }} {{ detail.exam.examDoModeCode == 'paper' ? '整卷模式' : '逐题模式' }}{{ `[${detail.exam.examName}]` }}
                            </div>
                        </div>
                        <div class="detail-bottom">                        
                            <img v-if="imgUrl" :src="imgUrl" alt="">
                            <img
                              v-else-if="detail.userInfo.sex == 'female'"
                              class="userInfo-img"
                              src="../../assets/female.png"
                              alt=""
                            />
                            <img
                              v-else
                              class="userInfo-img"
                              src="../../assets/male.png"
                              alt=""
                            />
                            <div class="user-name" v-if="detail.userInfo">{{detail.userInfo.userName}}({{detail.userInfo.name}})</div>
                            <div class="user-code" v-if="detail.userInfo">编号:{{detail.userInfo.userCode}}</div>
                            <div class="paper-message"> 
                                <span style="margin-right:18px;"><span class="label">共:</span> {{ `${detail.paperDetail.examPaper.questionNum}题` }} </span>
                                <span style="margin-right:18px;"><span class="label">满分:</span> {{ `${detail.paperDetail.examPaper.totalScore}分` }} </span>
                                <span ><span class="label">总时长:</span> {{examTime ? `${examTime}分钟`: ' 不限时'}}</span>
                            </div>
                        </div>                       
                    </div>
                    <div class="nav-right">
                        <span v-if="isSave" class="showSave" :class="hidden&&'hidden'">保存成功</span>                
                        <div class="operate-btn" v-if="!isStop">
                            <div class="exam-btn" @click.stop="save('save')" style="margin-right:42px;">
                                <img src="../../assets/exam/btn-save.png" alt="">
                                <span>保存</span>
                            </div>
                            <div class="exam-btn"  @click.stop="checkQuestion" style="margin-right:42px;">
                                <img src="../../assets/exam/btn-check.png" alt="">
                                <span>检查</span>
                            </div>
                            <div class="exam-btn"  @click.stop="pause" style="margin-right:42px;" v-if="detail.exam.isOpenBook">
                                <img src="../../assets/exam/btn-pause.png" alt="">
                                <span>暂停</span>
                            </div>
                            <div  class="exam-btn"   @click.stop="save('submit')" v-if="!isStop">
                                 <img src="../../assets/exam/btn-submit.png" alt="">
                                <span>交卷</span>
                            </div>                    
                        </div>
                    </div>
               </div>
            </div>
        </div>     
        <div class="exam-main">
            <el-row style="height: 100%">
                <el-col style="height: 100%;" :span="16">
                    <div class="main-left" :class="[isStop && 'disable', sizeClass]">
                           <div id="myModal" class="modal">
                                <span class="close">×</span>
                                <img class="modal-content" id="img01"/>
                                <!-- <div id="caption"></div> -->
                            </div>
                            <div class="sign-tips">
                                <span>点击</span>
                                <img style="margin:0 8px;width:18px;height:18px;vertical-align: middle" src="./../../assets/exam/isSign.png" alt="">
                                <span>或双击题目可对试题进行标记</span>
                            </div>
                            <div class="paper-detail" v-for="(item, index) in detail.paperDetail.paperNodes" :key="item.id">
                                <div class="node-head">{{ sortList[index] }}、{{ item.examPaperNode.paperNodeName }} <span class="tips">({{ item.examPaperNode.questionNum }}题<span v-if="detail.paperDetail.examPaper.isShowScore == 'Y'">,共{{ item.examPaperNode.totalScore }}分</span>) </span></div>
                                <div class="node-content">
                                    <div class="node-question" :id="subItem.id" v-for="(subItem, subIndex) in item.questions" :key="subItem.id">
                                        <div class="node-question-title" @dblclick="sign(subItem)">
                                            <span>{{ subIndex + 1 }}.</span>
                                            <span class="question-content" v-if="subItem.questionText"  v-html="subItem.questionText"></span>
                                            <span class="tips" v-if="detail.paperDetail.examPaper.isShowScore == 'Y'">({{ subItem.score }}分)</span>
                                            <span class="node-qusetion-typeName">{{ subItem.questionTypeName }}</span>
                                            <img  style="margin:0 8px;width:18px;height:18px;vertical-align: middle" @click="sign(subItem)" v-if="subItem.isSign" src="../../assets/exam/isSign-select.png" alt="">
                                            <img  style="margin:0 8px;width:18px;height:18px;vertical-align: middle" @click="sign(subItem)" v-else src="../../assets/exam/isSign.png" alt="">
                                        </div>
                                        <template v-if="subItem.questionBaseTypeCode == 'compose'">
                                             <div class="node-question" style="padding-left:16px;" :id="childItem.id" v-for="(childItem, childIndex) in subItem.childQuestions" :key="childItem.id">
                                                 <div class="node-question-title" @dblclick="sign(childItem)">
                                                    <span>{{ childIndex + 1 + ')' }}.</span>
                                                    <span  class="question-content" v-if="childItem.questionText" v-html="childItem.questionText"></span>
                                                    <span class="tips" v-if="detail.paperDetail.examPaper.isShowScore == 'Y'">({{ childItem.score }}分)</span>
                                                    <span class="node-qusetion-typeName">{{ childItem.questionTypeName }}</span>
                                                    <img  style="margin:0 8px;width:18px;height:18px;vertical-align: middle" @click="sign(childItem)" v-if="childItem.isSign" src="../../assets/exam/isSign-select.png" alt="">
                                                    <img  style="margin:0 8px;width:18px;height:18px;vertical-align: middle" @click="sign(childItem)" v-else src="../../assets/exam/isSign.png" alt="">
                                                </div>
                                                <template v-if="childItem.selectAnswers.length > 1 && childItem.questionBaseTypeCode == 'single'">                                                  
                                                    <el-radio-group v-model="childItem.answerText" style="width: 100%">
                                                        <div class="node-question-content" v-for="(item, index) in childItem.selectAnswerOrders" :key="`${childItem.id}${index}`">
                                                            <el-radio :label="item.selectValue">
                                                                <span class="text" style="margin-right: 8px;font-size:16px;">{{ item.selectDisplayValue}}.</span>
                                                                <div class="text" style="display: inline-block;max-width: 785px;line-height: 20px;word-break: break-all;white-space: pre-wrap;" v-html="item.selectText"></div
                                                            ></el-radio>
                                                        </div>
                                                    </el-radio-group>
                                                </template>
                                                <template v-if="childItem.questionBaseTypeCode == 'judge'">
                                                    <el-radio-group v-model="childItem.answerText" style="width: 100%">
                                                        <div class="node-question-content">
                                                            <el-radio class="text" label="Y">正确</el-radio>
                                                            <el-radio class="text" label="N">错误</el-radio>
                                                        </div>
                                                    </el-radio-group>
                                                </template>                                       
                                                <template v-if="childItem.questionBaseTypeCode == 'voice'">
                                                    <div class="node-question-answers" style=" display: flex;align-items: center;"> 
                                                        <!-- <vueAudio v-if="childItem.voiceUrls" :theControlList="controlList" theUrl="http://192.168.2.49:8081/api/app/file/download-file-system/6e7c93a7b12d4f4b887db4853ed1ec66"></vueAudio> -->
                                                        <el-button @click="showVoiceModal(childItem)" >开始作答</el-button>
                                                    </div>
                                                </template>
                                                <template v-if="childItem.questionBaseTypeCode == 'fill'">
                                                    <div class="node-question-answers" style="display:flex;flex-wrap:wrap;">
                                                        <div style="display:flex;" v-for="(item, index) in childItem.answerText" :key="`${childItem.id}${index}`">
                                                        <div style="display:flex;align-items: center;">
                                                            <div style="margin-right:8px;">{{index + 1}}.</div>
                                                            <el-input class="exam-input" 
                                                              @paste.native.capture.prevent="handleFalse"
                                                              @copy.native.capture.prevent="handleFalse"
                                                              @cut.native.capture.prevent="handleFalse" 
                                                              @input="answerInput(childItem)" 
                                                              :oncopy="false" 
                                                              v-model="item.text" 
                                                             ></el-input></div> <div style="display: flex;align-items: end;" v-if="index != childItem.standardAnswerCount - 1">、</div>
                                                        </div>                                              
                                                    </div>
                                                </template>                                   
                                                <template v-if="childItem.questionBaseTypeCode == 'judge_correct'">
                                                    <div class="node-question-answers">                                        
                                                        <el-radio-group style="width: 100%"  v-model="childItem.answerText">
                                                            <div class="node-question-content" style="display: inline-flex; border: none">
                                                                <el-radio  class="text" label="Y">正确</el-radio>
                                                                <el-radio class="text"  label="N">错误</el-radio>
                                                                <input class="exam-input" style=" width: 176px;height: 28px;background: #ffffff;border: 1px solid #999999;border-radius: 2px;" v-if="childItem.answerText == 'N'" v-model="childItem.text" ></input>
                                                            </div>
                                                        </el-radio-group>
                                                    </div>
                                                </template>
                                                <template v-if="childItem.questionBaseTypeCode == 'answer'">
                                                    <div class="node-question-answers">
                                                        <editor :id="`editor${index}${subIndex}`" v-if="childItem.isAnswerByHtml == 'Y'" v-model="childItem.answerText" style="width: 90%" :height="100" />
                                                        <el-input
                                                          @paste.native.capture.prevent="handleFalse"
                                                    @copy.native.capture.prevent="handleFalse"
                                                    @cut.native.capture.prevent="handleFalse" 
                                                        type="textarea" class="exam-input" v-else  v-model="childItem.answerText" name="" id="" cols="30" rows="1"></el-input>
                                                    </div>
                                                </template>
                                                <template v-if="childItem.selectAnswers.length > 1 && childItem.questionBaseTypeCode == 'multi'">                                                                                                                                                                                                     
                                                    <el-checkbox-group v-model="childItem.answerText" style="width: 100%">
                                                        <div class="node-question-content" v-for="(cItem, cIndex) in childItem.selectAnswerOrders"  :key="`${childItem.id}${cIndex}`">
                                                            <el-checkbox  @change="change(childItem)"   :label="cItem.selectValue"
                                                                ><span class="text" style="margin-right: 8px">{{ cItem.selectDisplayValue }}</span>
                                                                <div class="text" style="display: inline-block;max-width: 785px;line-height: 20px;word-break: break-all;white-space: pre-wrap;" v-html="cItem.selectText"></div
                                                            ></el-checkbox>
                                                        </div>
                                                    </el-checkbox-group>                                            
                                                </template>                                               
                                            </div>
                                        </template>
                                        <template v-if="subItem.selectAnswers.length > 1 && subItem.questionBaseTypeCode == 'single'">
                                            <el-radio-group v-model="subItem.answerText" style="width: 100%">
                                                <div class="node-question-content" v-for="(item, index) in subItem.selectAnswerOrders" :key="`${item.id}${index}`">
                                                    <el-radio :label="item.selectValue"
                                                        ><span class="text" style="margin-right: 8px;" >{{ item.selectDisplayValue }}.</span>
                                                        <div class="text" style="display: inline-block;max-width: 785px;line-height: 20px;word-break: break-all;white-space: pre-wrap;" v-html="item.selectText"></div
                                                    ></el-radio>
                                                </div>
                                            </el-radio-group>
                                        </template>
                                        <template v-if="subItem.questionBaseTypeCode == 'judge'">
                                            <el-radio-group v-model="subItem.answerText" style="width: 100%">
                                                <div class="node-question-content">
                                                    <el-radio class="text"  label="Y">正确</el-radio>
                                                    <el-radio class="text"  label="N">错误</el-radio>
                                                </div>
                                            </el-radio-group>
                                        </template>                                       
                                        <template v-if="subItem.questionBaseTypeCode == 'fill'">
                                            <div class="node-question-answers" style="display:flex;flex-wrap:wrap;">
                                                <div style="display:flex;margin-bottom:16px;" v-for="(item, index) in subItem.answerText" :key="item.id">
                                                    <div style="display:flex;align-items: center;">
                                                      <div style="margin-right:8px;">{{index + 1}}.</div>
                                                      <el-input 
                                                      @paste.native.capture.prevent="handleFalse"
                                                    @copy.native.capture.prevent="handleFalse"
                                                    @cut.native.capture.prevent="handleFalse"  @input="answerInput(subItem)" class="exam-input" v-model="item.text" ></el-input></div> <div style="display: flex;align-items: end;" v-if="index != subItem.standardAnswerCount - 1">、</div>
                                                </div>
                                            </div>
                                        </template>                                   
                                        <template v-if="subItem.questionBaseTypeCode == 'judge_correct'">
                                            <div class="node-question-answers">                                        
                                                <el-radio-group style="width: 100%"  v-model="subItem.answerText">
                                                    <div class="node-question-content" style="display: inline-flex; border: none">
                                                        <el-radio class="text" label="Y">正确</el-radio>
                                                        <el-radio class="text" label="N">错误</el-radio>
                                                        <input class="exam-input" style=" width: 176px;height: 28px;background: #ffffff;border: 1px solid #999999;border-radius: 2px;" v-if="subItem.answerText == 'N'" v-model="subItem.text" ></input>
                                                    </div>
                                                </el-radio-group>
                                            </div>
                                        </template>
                                        <template v-if="subItem.questionBaseTypeCode == 'answer'">
                                            <div class="node-question-answers" style="position: relative;">
                                                <el-upload action="" v-if="subItem.isAnswerByHtml == 'Y'" style="position: absolute;
                                                left: 118px;
                                                top: 15px;
                                                z-index: 999999;" :showFileList="false" :multiple ="false"   :http-request ="httpequest">  
                                                <i class="el-icon-folder-add" 
                                                style="
                                                font-size: 17px;
                                                color: #999999;"  @click="getId(subItem.id)"></i></el-upload>
                                                <editor :id="`editor${index}${subIndex}`" v-if="subItem.isAnswerByHtml == 'Y'"   @change="editorSubItem(subItem.id)"  v-model="subItem.answerText" style="width: 90%" :height="100" />
                                                <el-input type="textarea" class="exam-input"  
                                                    @paste.native.capture.prevent="handleFalse"
                                                    @copy.native.capture.prevent="handleFalse"
                                                    @cut.native.capture.prevent="handleFalse" 
                                                    v-else  v-model="subItem.answerText" name="" id="" cols="30" rows="1"></el-input>
                                            </div>
                                        </template>
                                        <template v-if="subItem.questionBaseTypeCode == 'voice'">
                                            <div class="node-question-answers" style=" display: flex;align-items: center;"> 
                                                <!-- <vueAudio v-if="subItem.voiceUrls" :theControlList="controlList" theUrl="http://192.168.2.49:8081/api/app/file/download-file-system/6e7c93a7b12d4f4b887db4853ed1ec66"></vueAudio> -->
                                              
                                                <el-button @click="showVoiceModal(subItem)" >开始作答</el-button>
                                            </div>
                                        </template>
                                        <template v-if="subItem.selectAnswers.length > 1 && subItem.questionBaseTypeCode == 'multi'">
                                            <el-checkbox-group v-model="subItem.answerText" style="width: 100%">
                                                <div class="node-question-content" v-for="(item) in subItem.selectAnswerOrders" :key="item.id">
                                                    <el-checkbox  @change="change(subItem)"   :label="item.selectValue"
                                                        ><span class="text" style="margin-right: 8px">{{ item.selectDisplayValue }}</span>
                                                        <div class="text" style="display: inline-block;max-width: 785px;line-height: 20px;word-break: break-all;white-space: pre-wrap;" v-html="item.selectText"></div
                                                    ></el-checkbox>
                                                </div>
                                            </el-checkbox-group>                                            
                                        </template>
                                    </div>
                                </div>
                            </div>
                    </div>
                </el-col>
                <el-col style="height: 100%" :span="6">
                    <div class="main-right">
                        <div class="time-remaining">
                            剩余时间           
                            <van-count-down v-if="cutdownTime == Infinity" ref="countDown" :time="99999999"  format="DD 天 HH 时 mm 分 ss 秒" >
                                <template #default="timeData">
                                  <span class="block">{{ 99  }}</span>
                                  <span class="block">:</span>
                                  <span class="block">{{ 99  }}</span>
                                  <span class="block">:</span>
                                  <span class="block">{{ 99  }}</span>
                                </template>
                            </van-count-down>
                            <van-count-down v-else ref="countDown" :time="cutdownTime"  @change="getTime"  :auto-start="true" format="DD 天 HH 时 mm 分 ss 秒" @finish="finish()">
                                <template #default="timeData">
                                  <span class="block">{{ timeData.hours < 10 ? '0' + timeData.hours :timeData.hours  }}</span>
                                  <span class="block">:</span>
                                  <span class="block">{{ timeData.minutes < 10 ? '0' + timeData.minutes :timeData.minutes  }}</span>
                                  <span class="block">:</span>
                                  <span class="block">{{ timeData.seconds < 10 ? '0' + timeData.seconds :timeData.seconds  }}</span>
                                </template>
                            </van-count-down>
                        </div>
                        <div class="examFaceModal" v-if="isShowFace" >
                            <faceModal  v-if="isShowFace" :isPushFlow="isPushFlow" :detail="faceDetail"></faceModal>
                        </div>
                        <div class="answers-card" ref="answers-card">
                            <div class="card-head">
                                答题卡
                            </div>
                            <div class="card-title">
                                <div  style="display: inline-flex;align-items: center;width:100%;height:100%;justify-content: space-around;padding:0 25px;">
                                    <div  class="title-item" >                                     
                                        <div class="noAnswer mg-rt"></div>
                                        <span>未答题</span>
                                    </div>
                                   <div class="title-item" >                                       
                                        <div class="isAnswer mg-rt"></div>
                                        <span>已答题</span>
                                   </div>
                                    <div class="title-item" >
                                        <div class="example-item mg-rt" >
                                            <div class="corner"></div>
                                            <div class="item-content">
                                                <div class="item-centre">
                                                </div>
                                            </div>
                                        </div>
                                        <div class="example-item finish mg-rt" >
                                            <div class="corner"></div>
                                            <div class="item-content">
                                                <div class="item-centre">
                                                </div>
                                            </div>
                                        </div>
                                        <span>已标记</span>
                                       
                                     </div>
                                     <div class="title-item">
                                          <div class="com-item finish mg-rt" >
                                            <div class="item-content">
                                                <div class="item-centre">
                                                </div>
                                            </div>
                                        </div>
                                        <span>组合题</span>
                                     </div>
                                </div>
                            </div>
                            <div class="card-modal">
                            <div class="question-modal" v-for="(itm, index) in detail.paperDetail.paperNodes" :key="`${itm.id}${index}`">                                
                                <div class="modal-title"><span>{{ itm.examPaperNode.paperNodeName }}</span><span class="tips"> ({{ `${itm.examPaperNode.questionNum}题` }})</span></div>
                                <div class="modal-content"  >
                                    <template v-for="(subItem, subIndex) in itm.questions" >                                     
                                        <a class="question-item"  v-if="subItem.questionBaseTypeCode != 'compose'" @click="clickQuestion(subItem)"  :class="[((subItem.answerText != undefined && !subItem.fillAnswer && subItem.questionBaseTypeCode != 'compose') || (subItem.questionBaseTypeCode == 'compose' && !subItem.fillAnswer) ||  (subItem.questionBaseTypeCode == 'voice' && !subItem.fillAnswer)) && 'finish'  ]"  :key="subItem.id">                                    
                                            <div class="item-content">
                                            <div class="corner" v-if="subItem.isSign"></div>
                                                <div class="item-centre">
                                                    {{subIndex + 1 }}
                                                </div>                                             
                                            </div>
                                        </a>
                                        <div  :key="subItem.id"  v-else  style="width: 100%;display: flex;">
                                            <div  style="width: 100%;display: flex;">
                                               <a class="compose-item" @click="clickQuestion(subItem)"  :class="[((subItem.answerText != undefined && !subItem.fillAnswer && subItem.questionBaseTypeCode != 'compose') || (subItem.questionBaseTypeCode == 'compose' && !subItem.fillAnswer) ||  (subItem.questionBaseTypeCode == 'voice' && !subItem.fillAnswer)) && 'finish'  ]">
                                                    <div class="item-content">
                                                        <div class="corner" v-if="subItem.isSign"></div>
                                                        <div class="item-centre">
                                                             {{subIndex + 1 }}
                                                        </div>                                             
                                                    </div>
                                               </a>
                                               <template v-if="subItem.childQuestions && subItem.childQuestions.length">
                                                   <a class="question-item" @click="clickQuestion(childItem)"  :class="[((childItem.answerText != undefined && !childItem.fillAnswer && childItem.questionBaseTypeCode != 'compose') || (childItem.questionBaseTypeCode == 'compose' && !childItem.fillAnswer) ||  (childItem.questionBaseTypeCode == 'voice' && !childItem.fillAnswer)) && 'finish'  ]"   v-for="(childItem,childIndex) in subItem.childQuestions" :key="childItem.id">
                                                     <div class="item-content">
                                                        <div class="corner" v-if="childItem.isSign"></div>
                                                            <div class="item-centre" @click="warnItem(childItem)">
                                                                {{`${childIndex + 1}` }}
                                                            </div>                                             
                                                        </div>
                                                   </a>
                                               </template>
                                            </div>
                                        </div>
                                    </template>
                                </div>
                            </div>                                                                            
                            </div>

                        </div>
                      
                    </div>
                </el-col>
            </el-row>
        </div>
    </div>
</template>
<script>
import axios from "axios";
import $ from "jquery";
import Api from "@/api/paper";
import { useFullscreen } from "@vueuse/core";
import Editor from "@/components/wangEditor/wangEditor";
import Recorder from "js-audio-recorder";
const { isFullscreen, enter } = useFullscreen();
import vueAudio from "@/components/vueAudio/vueAudio";
import faceModal from "@/components/examFace";
import QRCode from "../../plugin/qrcode.js";

export default {
  components: {
    Editor,
    vueAudio,
    faceModal,
    // "el-image-viewer": () =>
    //   import("element-ui/packages/image/src/image-viewer"),
  },
  data() {
    return {
      controlList:
        "noDownload noVolume noMuted noSpeed noProcess onlyOnePlaying",
      voiceDetail: {
        questionText: "",
        answerText: "",
      },
      src: "",
      isPushFlow: false, // 是否开推流
      voiceType: "",
      count: 0,
      noOperationNum: 0,
      noOperationCount: 0,
      noOperation: false,
      isFullscreen,
      examTime: 0,
      sizeClass: "normal",
      fontValue: 0,
      canSeeGrade: true,
      gradeScore: "",
      pauseDialogVisible: false,
      dialogVisible: false,
      showEditor: false,
      isSignNum: 0,
      examUid: "",
      gradeRate: 0,
      examArrangeUid: "",
      examGradeUid: "",
      answerDialogVisible: false,
      isBreakOffFace: false,
      isCheckFace: false,
      isConnectingInterval: null,
      isAllowViewPaperNow: true,
      isDisplayResult: false,
      isShowTop: false,
      isPass: false,
      isNeedJudge: false,
      detail: {
        paperDetail: {
          examPaper: {
            questionNum: "-",
            totalScore: "-",
          },
        },
        exam: {
          examTime: "-",
          examName: "-",
          isOpenBook: false,
          examDoModeCode: "paper",
        },
        examGrade: {
          allowExamTime: 0,
        },
        paperNodes: [],
        userInfo: {},
      },
      imgUrl: "",
      userInfo: {},
      isSave: false,
      hidden: false,
      unfinishedNum: 0,
      submitDialogVisible: false,
      saveDialogVisible: false,
      voiceDialogVisible: false,
      startTime: "",
      cutdownTime: Infinity, //答卷倒计时时长
      cutdownNum: 10, //答卷倒计时时长
      selectType: ["A", "B", "C", "D", "E", "F", "G", "H"],
      sortList: ["一", "二", "三", "四", "五", "六", "七", "八", "九", "十"],
      isStop: false,
      msg: [],
      params: {},
      fullscreen: false, //全屏，fasle默认不是全屏，true为全屏
      isPause: false,
      isPauseText: "",
      isExistsDetail: false,
      isConnecting: JSON.parse(sessionStorage.getItem("isConnecting")),
      autosave: null,
      useExamTime: 0,
      recorder: {},
      isRecord: false,
      noOpTimeOut: null,
      noOpInterval: null,
      faceDetail: {},
      isShowFace: false,
      changeLoading: false,
      getAvID: "",
      getAvIDBB: "",
      editorResList: [],
      userId: "",
      roomId: "",
      qrCodeModal: null,
      AudioControlOperationMaxCount: 100,
      AudioControlOperationCount: 0,
      canplayMaxRetries: 10,
      submitFailDialogVisible: false,
    };
  },
  methods: {
    handleFalse() {
      //终止
      //   if (this.detail.exam.isForbidCopyPasteCut) {
      return false;
      //   } else {
      // return true;
      //   }
    },
    warnItem(item) {
      console.warn(item);
    },
    enter,
    paseAudioCloseVoiceDialogVisible() {
      let audios = document.querySelectorAll("[class='voice-content'] audio");
      if (!audios || audios.length == 0) {
        return;
      }
      for (let i = 0; i < audios.length; i++) {
        audios[i] && audios[i].pause && audios[i].pause();
      }
    },
    //开始录音
    closeVoiceDialogVisible() {
      this.stopPlayRecorder();
      this.recorderStop();
      this.paseAudioCloseVoiceDialogVisible(); //停止录音播放
      this.voiceDialogVisible = false;
      // this.voiceDetail.voiceType = '';
    },
    autoCloseVoiceDialogVisible() {
      this.autoStopPlayRecorder();
      this.autoRecorderStop();
      this.paseAudioCloseVoiceDialogVisible();
      this.voiceDialogVisible = false;
    },
    showVoiceModal(item) {
      // this.voiceDetail.voiceType = '';
      // this.initRecord();
      if ((item.recorder && !item.recorder.start) || !item.recorder) {
        this.initRecord(item.recorder);
      }
      console.warn(item);
      this.voiceDetail = item;
      this.voiceDialogVisible = true;
      this.$forceUpdate();
    },
    closeSubmitFailDialogVisible() {
      this.submitFailDialogVisible = false;
    },
    checkRecord() {
      this.changeLoading = false;
      let fileRelationId = `${this.detail.examGrade.id}_${this.voiceDetail.id}`;
      let formData = new FormData();
      let file = this.voiceDetail.recorder.getWAVBlob();
      file = new File([file], fileRelationId);
      formData.append("file", file);
      formData.append("fileName", fileRelationId);
      this.voiceDetail.fillAnswer = false;
      axios
        .post(
          `/api/app/file/upload-file-system?fileTypeCode=anweerVioce&fileRelationId=${fileRelationId}`,
          formData
        )
        .then((res) => {
          console.warn(res);
          this.$message.success("上传成功");
          this.voiceDetail.answerText = `<audio controls src="${res.data.fileServerUrl}"></audio>`;
          this.detail.paperDetail.paperNodes.forEach((item) => {
            item.questions.forEach((subItem) => {
              if (
                subItem.questionBaseTypeCode == "voice" &&
                subItem.id == this.voiceDetail.id
              ) {
                subItem.isUpload = true;
                subItem.answerText == this.voiceDetail.answerText;
              }
            });
          });
          this.voiceDialogVisible = false;
          this.$forceUpdate();
          // this.handleClose();
        })
        .catch((err) => {
          this.$message.error(err);
        });
    },
    recorderStart() {
      this.changeLoading = true;
      this.voiceDetail.recorder = new Recorder({
        sampleBits: 16, // 采样位数，支持 8 或 16，默认是16
        sampleRate: 16000, // 采样率，支持 11025、16000、22050、24000、44100、48000，根据浏览器默认值，我的chrome是48000
        numChannels: 1, // 声道，支持 1 或 2， 默认是1
        // compiling: false,(0.x版本中生效,1.x增加中)  // 是否边录边转换，默认是false
      });
      this.voiceDetail.isRecord = true;
      this.voiceDetail.recorder.start().then(
        () => {
          // 开始录音
          let _this = this;
          this.voiceDetail.recorder.onprogress = function (params) {
            _this.voiceDetail.recorder.voiceTime = params.duration.toFixed(0);
            _this.$forceUpdate();
            // console.log('当前录音的总数据([DataView, DataView...])', params.data);
          };
          this.$message.success("开始录音");
          this.voiceDetail.voiceType = "play";
          this.voiceDetail.isRecord = true;
          //console.warn(this.voiceDetail.voiceType);
          this.$forceUpdate();
        },
        (error) => {
          // 出错了
          // this.checkError(error)
          this.destroyRecorder();
          this.voiceDetail.isRecord = false;
          this.changeLoading = false;
          //console.log(this.checkError(error));
          this.$message.error(this.checkError(error).error);
        }
      );
    },
    //继续录音
    resumeRecorder() {
      if (this.voiceDetail.isRecord) {
        this.voiceDetail.recorder.resume();
        this.voiceDetail.voiceType = "continuePlay";
        this.$forceUpdate();
      } else {
        this.$message.error("暂未开始录音");
      }
      //console.warn(this.voiceDetail.voiceType);
    },
    // 暂停录音
    pauseRecorder() {
      this.changeLoading = false;
      if (this.voiceDetail.isRecord) {
        this.voiceDetail.voiceType = "pause";
        this.voiceDetail.recorder.pause();
        this.$forceUpdate();
      } else {
        this.$message.error("暂未开始录音");
      }
      //console.warn(this.voiceDetail.voiceType);
    },
    // 结束录音
    recorderStop() {
      this.changeLoading = false;
      if (!this.autoRecorderStop()) {
        this.$message.error("暂未开始录音");
      }
      //console.warn(this.voiceDetail.voiceType);
    },
    autoRecorderStop() {
      this.changeLoading = false;
      if (this.voiceDetail.isRecord) {
        this.voiceDetail.voiceType = "stop";
        this.voiceDetail.recorder.stop();
        this.$forceUpdate();
        return true;
      }
      return false;
    },
    // 录音播放
    playRecorder() {
      if (this.voiceDetail.isRecord) {
        this.voiceType = "play";
        this.voiceDetail.recorder.play();
        this.$forceUpdate();
      } else {
        this.$message.error("暂未开始录音");
      }
    },
    // 暂停录音播放
    pausePlayRecorder() {
      if (this.voiceDetail.isRecord) {
        this.voiceType = "pause";
        this.voiceDetail.recorder.pausePlay();
        this.$forceUpdate();
      } else {
        this.$message.error("暂未开始录音");
      }
      //console.warn("voiceType", this.voiceType);
      //console.warn("voiceDetail.voiceType", this.voiceDetail.voiceType);
    },
    // 恢复录音播放
    resumePlayRecorder() {
      if (this.voiceDetail.isRecord) {
        this.voiceType = "play";
        this.voiceDetail.recorder.resumePlay();
      } else {
        this.$message.error("暂未开始录音");
      }
      this.$forceUpdate();
    },
    // 停止录音播放
    stopPlayRecorder() {
      if (!this.autoStopPlayRecorder()) {
        this.$message.error("暂未开始录音");
      }
      this.$forceUpdate();
    },
    autoStopPlayRecorder() {
      if (this.voiceDetail.isRecord) {
        this.voiceType = "";
        this.voiceDetail.recorder.stopPlay();
        this.$forceUpdate();
        return true;
      }
      return false;
    },
    // 销毁录音
    destroyRecorder() {
      this.voiceDetail.recorder.destroy().then(() => {
        this.voiceDetail.recorder.recorder = null;
      });
      this.$forceUpdate();
    },
    //挂载录音插件
    initRecord(item) {
      item = new Recorder({
        sampleBits: 16, // 采样位数，支持 8 或 16，默认是16
        sampleRate: 16000, // 采样率，支持 11025、16000、22050、24000、44100、48000，根据浏览器默认值，我的chrome是48000
        numChannels: 1, // 声道，支持 1 或 2， 默认是1
        // compiling: false,(0.x版本中生效,1.x增加中)  // 是否边录边转换，默认是false
      });
      console.warn("录音插件挂载", item);
    },
    //录音报错判断
    checkError(e) {
      this.changeLoading = false;
      const { name } = e;
      console.warn(e);
      let errorMsg = "";
      let dicError = {
        AbortError: "录音设备无法被使用",
        NotAllowedError: "用户已禁止网页调用录音设备",
        PermissionDeniedError: "用户已禁止网页调用录音设备",
        NotFoundError: "录音设备未找到",
        DevicesNotFoundError: "录音设备未找到",
        NotReadableError: "录音设备无法使用",
        NotSupportedError: "不支持录音功能",
        MandatoryUnsatisfiedError: "无法发现指定的硬件设备",
      };
      errorMsg = dicError[name] || "录音调用错误";
      return { error: errorMsg };
    },
    submitVoice() {
      this.recorderStop();
      this.stopPlayRecorder();
      this.checkRecord();
      this.paseAudioCloseVoiceDialogVisible(); //停止录音播放
    },
    enterFullScreen() {
      if (typeof this.isFullscreen == "object") {
        if (!this.isFullscreen.value) {
          this.enter();
        }
      } else {
        if (!this.isFullscreen) {
          this.enter();
        }
      }
      // let modal = document.getElementById("myModal");
      // if (modal.style.display == "flex") {
      //   modal.style.display = none;
      // }
    },
    formatTooltip(val) {
      let text = " ";
      let sizeVal = ["正常", "中等", "大", "超大"];
      val = val < 0 || val >= sizeVal.length ? 0 : val;
      text = sizeVal[val] || sizeVal[0];
      this.$forceUpdate();
      return text;
    },
    fontChange(size) {
      let classSize = ["normal", "center", "big", "oversized"];
      size = size < 0 || size >= classSize.length ? 0 : size;
      this.sizeClass = classSize[size] || classSize[0];
      this.$forceUpdate();
    },
    getTime(item) {
      this.useExamTime =
        this.detail.examGrade.allowExamTime -
        item.hours * 3600 -
        item.minutes * 60 -
        item.seconds;
      sessionStorage.setItem("cutdownTime", this.useExamTime);
    },
    clearAutosave() {
      clearInterval(this.autosave);
    },
    //浏览器进入全屏
    enterScreen() {
      let element = document.getElementById("exam") || document.documentElement; //设置后就是 id==xxxx 的容器全屏
      if (element.requestFullscreen) {
        element.requestFullscreen();
      } else if (element.webkitRequestFullScreen) {
        element.webkitRequestFullScreen();
      } else if (element.mozRequestFullScreen) {
        element.mozRequestFullScreen();
      } else if (element.msRequestFullscreen) {
        element.msRequestFullscreen();
      }
      this.fullscreen = true;
    },
    enterScreen() {
      let lis = document.getElementById("exam");
      lis.addEventListener("keydown", function (e) {
        if (e.keyCode === 38) {
          // up rotate
          alert("38");
        } else if (e.keyCode === 40) {
          // down
          alert("40");
        } else if (e.keyCode === 37) {
          // left
          alert("37");
        } else if (e.keyCode === 39) {
          // right
          alert("39");
        } else if (e.keyCode === 32) {
          //  space  下坠
          alert("32");
        }
      });
    },
    change(e) {
      e.fillAnswer = false;
      this.$forceUpdate();
    },
    //   即时通讯模块
    screenNoSendMessage(item) {
      // 筛选出不是发送消息的元素
      if (item.commandName != "SendMessage") {
        return item;
      } else {
        return false;
      }
    },
    screenForceToSubmit(item) {
      //筛选出强行提交的元素
      if (item.commandName == "ForceToSubmit") {
        return item;
      } else {
        return false;
      }
    },
    screenSendMessage(item) {
      // 筛选出发送消息的元素
      if (item.commandName == "SendMessage") {
        return item;
      } else {
        return false;
      }
    },
    screenPauseAndEndPauseExam(item) {
      //筛选出暂停和继续考试的元素
      if (
        item.commandName == "EndPauseExam" ||
        item.commandName == "PauseExam"
      ) {
        return item;
      } else {
        return false;
      }
    },
    sortTime(property) {
      return function (a, b) {
        let value1 = a[property];
        let value2 = b[property];
        return new Date(value1).getTime() - new Date(value2).getTime();
      };
    },
    getOperationList(params) {
      params.commandStatusCode = "wait";
      Api.operationList(params)
        .then((res) => {
          if (res.data.length > 0) {
            let operationList = [];
            if (res.data.filter(this.screenNoSendMessage)) {
              let noMessageList = res.data.filter(this.screenNoSendMessage);
              if (noMessageList.filter(this.screenForceToSubmit).length != 0) {
                operationList.push(
                  noMessageList.filter(this.screenForceToSubmit)[0]
                );
              } else {
                if (noMessageList.filter(this.screenPauseAndEndPauseExam)) {
                  operationList.push(
                    ...noMessageList.filter(this.screenPauseAndEndPauseExam)
                  );
                }
              }
            }
            if (res.data.filter(this.screenSendMessage)) {
              operationList.push(...res.data.filter(this.screenSendMessage));
            }
            if (operationList.length > 1) {
              operationList.sort(this.sortTime("creationTime"));
            }
            for (let i = 0; i < operationList.length; i++) {
              switch (operationList[i].commandName) {
                case "ForceToSubmit":
                  console.warn("强行提交");
                  this.save("force");
                  break;
                case "PauseExam":
                  console.warn("暂停考试");
                  this.pauseExam(operationList[i].examGradeUid);
                  this.pauseTime();
                  break;
                case "EndPauseExam":
                  console.warn("解除考试暂停");
                  this.resumeExam(operationList[i].examGradeUid);
                  this.continueExam();
                  break;
                case "SendMessage":
                  console.warn("发送消息", operationList[i]);
                  // alert(operationList[i].commandPara);
                  this.$alert(operationList[i].commandPara, "消息通知", {
                    confirmButtonText: "确定",
                  });
                  break;
              }
            }
          }
        })
        .catch((err) => {
          console.warn(err);
        });
    },
    updateExamStatus(id) {
      let params = [];
      if (id) {
        params.push(id);
      }
      Api.updateStatus(params)
        .then((res) => {
          console.warn(res);
        })
        .catch((err) => {
          console.warn(err);
        });
    },
    pauseExam(gradeUid) {
      Api.pauseExam(gradeUid)
        .then((res) => {
          (this.pauseDialogVisible = true), (this.isPause = true);
          console.warn(res);
        })
        .catch((err) => {
          console.warn(err);
        });
    },
    resumeExam(gradeUid) {
      Api.resumeExam(gradeUid)
        .then((res) => {
          (this.pauseDialogVisible = false), (this.isPause = false);
          console.warn(res);
        })
        .catch((err) => {
          console.warn(err);
        });
    },
    //

    goAnswerPaper() {
      this.answerDialogVisible = false;
      this.$router.replace(
        `/exam/paper/detail?examUid=${this.examUid}&examGradeUid=${this.examGradeUid}`
      );
    },
    closePaper() {
      window.opener = null;
      window.open("", "_self");
      window.close();
    },
    finish() {
      console.warn(this.cutdownTime);
      this.save("finish");
      this.autoCloseVoiceDialogVisible();
    },
    continueExam() {
      this.pauseDialogVisible = false;
      this.isPause = false;
      this.isBreakOffFace = false;
      if (this.cutdownTime != Infinity) {
        this.$refs.countDown.start();
      }
    },
    pauseTime() {
      if (this.cutdownTime != Infinity) {
        this.$refs.countDown.pause();
      }
    },
    pause() {
      if (this.cutdownTime != Infinity) {
        this.pauseTime();
      }
      this.pauseDialogVisible = true;
      this.save("forceSave");
    },
    handleClose(done) {
      done();
    },
    checkQuestion() {
      this.isSignNum = 0;
      this.dialogVisible = true;
      this.unfinishedNum = 0;
      this.detail.paperDetail.paperNodes.forEach((item) => {
        item.questions.forEach((subItem) => {
          if (subItem.fillAnswer) {
            this.unfinishedNum += 1;
          }
          if (subItem.isSign) {
            this.isSignNum += 1;
          }
        });
      });
    },
    clickQuestion(item) {
      console.warn(item.id);
      document.getElementById(`${item.id}`).scrollIntoView({
        block: "center",
        behavior: "smooth",
      });
    },
    checkValue(obj) {
      return obj.text != " " && obj.text != "";
    },
    sendMessageToApp() {
      console.warn("通知移动端抓拍");
      // let params = {
      //   receiveUserId: sessionStorage.getItem("userId"),
      //   methodName: "MessageToApp",
      //   msgContent: "移动端抓拍",
      // };
      axios
        .post(
          `/api/base/signalR/send/user/publish?receiveUserId=${sessionStorage.getItem(
            "userId"
          )}&methodName=MessageToApp&msgContent=移动端抓拍`
        )
        .then((result) => {
          console.warn(result);
        })
        .catch((err) => {});
    },
    answerInput(item) {
      if (item.answerText.every(this.checkValue)) {
        item.fillAnswer = false;
      } else {
        item.fillAnswer = true;
      }
      this.$forceUpdate();
    },
    sign(item) {
      if (item.isSign != undefined) {
        item.isSign = !item.isSign;
      } else {
        item.isSign = true;
      }
      this.$forceUpdate();
    },
    closePage() {
      this.$router.replace("/exam/list");
    },
    save(type) {
      //console.warn("type", type);
      let Text = type == "save" ? "保存" : "提交";
      this.unfinishedNum = 0;
      let params = {
        examAnswers: [],
      };
      //console.warn(this.detail.paperDetail.paperNodes);
      this.detail.paperDetail.paperNodes.forEach((item) => {
        item.questions.forEach((subItem) => {
          console.warn(subItem);
          if (subItem.fillAnswer) {
            this.unfinishedNum += 1;
            if (subItem.questionBaseTypeCode == "fill") {
              let obj = {
                questionUid: subItem.id,
                isSetBookMark: subItem.isSign ? true : false,
              };
              let textArr = [];
              if (
                subItem.answerText.includes('span style="font-weight: normal')
              ) {
                subItem.answerText = subItem.answerText.replace(
                  /<span style="font-weight: normal;">/g,
                  ""
                );
                subItem.answerText = subItem.answerText.replace(
                  /<\/span>/g,
                  ""
                );
                subItem.answerText = subItem.answerText.replace(/<br\/>/g, "");
                console.warn(subItem.answerText);
              }
              if (subItem.answerText.includes("img")) {
                subItem.answerText = subItem.answerText.replace(
                  /http:\/\/.+?\//,
                  "/"
                );
                subItem.answerText = subItem.answerText.replace(
                  /(<img.+?\/)>/gm,
                  "$1&gt;"
                );
                subItem.answerText = subItem.answerText.replace(
                  /<(img.+src)/gm,
                  "&lt;$1"
                );
                //console.warn(subItem.answerText);
              }
              if (subItem.answerText.length > 1) {
                subItem.answerText.forEach((item) => {
                  if (item.text != "") {
                    item.text = item.text.trim();
                  }
                  textArr.push(item.text);
                });
                //console.warn("textArr", textArr);
                obj.answerText = textArr.join("$contentsplit$");
              } else {
                obj.answerText = subItem.answerText[0].text;
              }
              params.examAnswers.push(obj);
            }
          } else if (subItem.fillAnswer == false) {
            let obj = {
              questionUid: subItem.id,
              isSetBookMark: subItem.isSign ? true : false,
            };

            if (Array.isArray(subItem.answerText)) {
              if (subItem.answerText.length == 0) {
                obj.answerText = "";
              } else if (subItem.answerText.length == 1) {
                obj.answerText = subItem.answerText[0];
              } else {
                obj.answerText = subItem.answerText.join("$contentsplit$");
              }
            } else {
              obj.answerText = subItem.answerText;
            }
            if (
              subItem.questionBaseTypeCode == "judge_correct" &&
              subItem.answerText == "N"
            ) {
              if (subItem.text) {
                obj.answerText = `N$contentsplit$${subItem.text}`;
              } else {
                obj.answerText = `N$contentsplit$`;
              }
            }
            if (subItem.questionBaseTypeCode == "answer") {
              if (
                subItem.answerText.includes('span style="font-weight: normal')
              ) {
                subItem.answerText = subItem.answerText.replace(
                  /<span style="font-weight: normal;">/g,
                  ""
                );
                subItem.answerText = subItem.answerText.replace(
                  /<\/span>/g,
                  ""
                );
                subItem.answerText = subItem.answerText.replace(/<br\/>/g, "");
                //warn(subItem.answerText);
              }
              if (subItem.answerText.includes("img")) {
                subItem.answerText = subItem.answerText.replace(
                  /<img.+?(src=".+?").+?\/>/gi,
                  '<img $1 style="width:200px;height:200px" contenteditable="false" @click="aaaa" class="TMD" />'
                );
                obj.answerText = subItem.answerText;
                //console.warn(subItem.answerText, obj.answerText);
              }
            }
            if (subItem.questionBaseTypeCode == "fill") {
              let textArr = [];
              //console.warn(subItem.answerText);
              if (subItem.answerText.length > 1) {
                subItem.answerText.forEach((item) => {
                  textArr.push(item.text);
                });
                //console.warn("textArr", textArr);
                obj.answerText = textArr.join("$contentsplit$");
              } else {
                obj.answerText = subItem.answerText[0].text;
              }
            }
            params.examAnswers.push(obj);
          }
          if (subItem.questionBaseTypeCode == "compose") {
            subItem.childQuestions.forEach((childItem) => {
              if (childItem.fillAnswer == false) {
                let obj = {
                  questionUid: childItem.id,
                  isSetBookMark: childItem.isSign ? true : false,
                };

                if (Array.isArray(childItem.answerText)) {
                  if (childItem.answerText.length == 0) {
                    obj.answerText = "";
                  } else if (childItem.answerText.length == 1) {
                    obj.answerText = childItem.answerText[0];
                  } else {
                    obj.answerText =
                      childItem.answerText.join("$contentsplit$");
                  }
                } else {
                  obj.answerText = childItem.answerText;
                }
                if (
                  childItem.questionBaseTypeCode == "judge_correct" &&
                  childItem.answerText == "N"
                ) {
                  if (childItem.text) {
                    obj.answerText = childItem.text;
                  }
                }
                if (childItem.questionBaseTypeCode == "fill") {
                  let textArr = [];
                  if (childItem.answerText.length > 1) {
                    childItem.answerText.forEach((item) => {
                      textArr.push(item.text);
                    });
                    obj.answerText = textArr.join("$contentsplit$");
                  } else {
                    obj.answerText = childItem.answerText[0].text;
                  }
                }
                params.examAnswers.push(obj);
              }
            });
          }
          params.noAnswerQuestionNum = this.unfinishedNum;
        });
      });
      if (type == "submit") {
        params.examArrangeUid = this.detail.examGrade.examArrangeUid;
        if (this.detail.exam.forbitSubmitBeforeTime != 0) {
          if (this.useExamTime < this.detail.exam.forbitSubmitBeforeTime) {
            this.$message.error(
              `至少作答${
                this.detail.exam.forbitSubmitBeforeTime / 60
              }分钟后交卷`
            );
            return;
          }
        }
      }
      if (type == "finish") {
        params.examArrangeUid = this.detail.examGrade.examArrangeUid;
        this.isStop = true;
        Api.submitPaper(this.detail.exam.id, this.detail.examGrade.id, params)
          .then((res) => {
            this.examGradeUid = res.data.examGradeUid;
            this.gradeScore = res.data.gradeScore;
            this.isAllowViewPaperNow = res.data.isAllowViewPaperNow;
            this.canSeeGrade = res.data.canSeeGrade;
            this.isPass = res.data.isPass;
            this.isDisplayResult = res.data.isDisplayResult;
            if (res.data.gradeRate != 0) {
              this.gradeRate = res.data.gradeRate.toFixed(2);
            }

            this.answerDialogVisible = true;
            this.autoCloseVoiceDialogVisible();
            this.$forceUpdate();
            if (localStorage.getItem("examList").length != 0) {
              let list = JSON.parse(localStorage.getItem("examList"));
              let arr = list;
              for (let i = 0; i < arr.length; i++) {
                if (arr[i].examGrade.id == this.detail.examGrade.id) {
                  arr.splice(i, 1);
                }
              }
              localStorage.setItem("examList", JSON.stringify(arr));
            }
          })
          .catch((err) => {
            //this.answerDialogVisible = true;
            console.log(err);
            if(err.response&&err.response.status!=403){
                  this.submitFailDialogVisible=true;
             }
            if(!err.response){
                this.submitFailDialogVisible=true;
            }
          });
        return;
      }
      if (type == "force") {
        Api.submitForcePaper(
          this.detail.exam.id,
          this.detail.examGrade.id,
          params
        )
          .then((res) => {
            this.isShowFace = false;
            this.gradeScore = res.data.gradeScore;
            this.answerDialogVisible = true;
            this.examGradeUid = res.data.examGradeUid;
            this.isAllowViewPaperNow = res.data.isAllowViewPaperNow;
            this.canSeeGrade = res.data.canSeeGrade;
            this.isNeedJudge = res.data.isNeedJudge;
            this.isPass = res.data.isPass;
            this.isDisplayResult = res.data.isDisplayResult;
            if (res.data.gradeRate != 0) {
              this.gradeRate = res.data.gradeRate.toFixed(2);
            }
            this.answerDialogVisible = true;
            this.autoCloseVoiceDialogVisible();
            if (localStorage.getItem("examList").length != 0) {
              let list = JSON.parse(localStorage.getItem("examList"));
              let arr = list;
              for (let i = 0; i < arr.length; i++) {
                if (arr[i].examGrade.id == this.detail.examGrade.id) {
                  arr.splice(i, 1);
                }
              }
              localStorage.setItem("examList", JSON.stringify(arr));
            }
            window.onblur = null;
            window.onfocus = null;
            this.signalr.invoke("ClearExam").catch(function (err) {
              return console.error(err.toString());
            });
          })
          .catch((err) => {
             console.log(err);
            //this.answerDialogVisible = true;
            if(err.response&&err.response.status!=403){
                  this.submitFailDialogVisible=true;
             }
            if(!err.response){
                this.submitFailDialogVisible=true;
            }
          });
          return;
      } else if (type == "forceSave") {
        Api.savePaper(this.detail.exam.id, this.detail.examGrade.id, params)
          .then((res) => {
            this.$message.success("答案已自动保存");
            //console.warn(res);
          })
          .catch((err) => {
            //console.warn(err);
          });
      } else {
        let saveText = "";
        if (this.unfinishedNum) {
          saveText = `您还有${this.unfinishedNum}题未完成,确定${Text}吗?`;
        } else {
          saveText = `确定${Text}吗?`;
        }
        this.$confirm(`${saveText}`, "提示", {
          confirmButtonText: "确定",
          cancelButtonText: "取消",
          type: "warning",
        })
          .then(() => {
            if (type == "save") {
              Api.savePaper(
                this.detail.exam.id,
                this.detail.examGrade.id,
                params
              )
                .then((res) => {
                  this.$message.success("保存成功");
                  // console.warn(res);
                })
                .catch((err) => {
                  console.log(err);
                  if(err.response&&err.response.status!=403){
                    this.submitFailDialogVisible=true;
                  }
                  if(!err.response){
                    this.submitFailDialogVisible=true;
                  }
                });
            } else {
              Api.submitPaper(
                this.detail.exam.id,
                this.detail.examGrade.id,
                params
              )
                .then((res) => {
                  this.isShowFace = false;
                  this.examGradeUid = res.data.examGradeUid;
                  this.gradeScore = res.data.gradeScore;
                  this.isAllowViewPaperNow = res.data.isAllowViewPaperNow;
                  this.canSeeGrade = res.data.canSeeGrade;
                  this.isNeedJudge = res.data.isNeedJudge;
                  this.isPass = res.data.isPass;
                  this.isDisplayResult = res.data.isDisplayResult;
                  if (res.data.gradeRate != 0) {
                    this.gradeRate = res.data.gradeRate.toFixed(2);
                  }
                  this.answerDialogVisible = true;
                  this.autoCloseVoiceDialogVisible();
                  this.$forceUpdate();
                  if (localStorage.getItem("examList").length != 0) {
                    let list = JSON.parse(localStorage.getItem("examList"));
                    let arr = list;
                    for (let i = 0; i < arr.length; i++) {
                      if (arr[i].examGrade.id == this.detail.examGrade.id) {
                        arr.splice(i, 1);
                      }
                    }
                    localStorage.setItem("examList", JSON.stringify(arr));
                  }
                  window.onblur = null;
                  window.onfocus = null;
                  this.signalr.invoke("ClearExam").catch(function (err) {
                    return console.error(err.toString());
                  });
                })
                .catch((err) => {
                  //alert(err);
                  //this.answerDialogVisible = true;
                  if(err.response&&err.response.status!=403){
                     this.submitFailDialogVisible=true;
                  }
                  if(!err.response){
                     this.submitFailDialogVisible=true;
                  }
                });
            }
          })
          .catch((ex) => {
            console.log(ex);
          });
      }
    },
    showSaveModal() {
      Api.savePaper(this.detail.exam.id, this.detail.examGrade.id, this.params)
        .then((res) => {
          // this.$message.success('保存成功');
          // console.warn(res);
          this.saveDialogVisible = false;
          this.isSave = true;
          let time = setTimeout(() => {
            this.hidden = true;
            clearTimeout(time);
            let hidden = setTimeout(() => {
              this.isSave = false;
              this.hidden = false;
              clearTimeout(hidden);
            }, 1000);
          }, 3000);
        })
        .catch((err) => {
          console.warn(err);
          this.$message.erroe("保存失败");
          this.saveDialogVisible = false;
        });
    },
    showSubmitModal() {
      Api.submitPaper(
        this.detail.exam.id,
        this.detail.examGrade.id,
        this.params
      )
        .then((res) => {
          this.examGradeUid = res.data.examGradeUid;
          this.isShowFace = false;
          this.gradeScore = res.data.gradeScore;
          this.isAllowViewPaperNow = res.data.isAllowViewPaperNow;
          this.canSeeGrade = res.data.canSeeGrade;
          this.isNeedJudge = res.data.isNeedJudge;
          this.isPass = res.data.isPass;
          this.isDisplayResult = res.data.isDisplayResult;
          if (res.data.gradeRate != 0) {
            this.gradeRate = res.data.gradeRate.toFixed(2);
          }

          this.answerDialogVisible = true;
          this.$forceUpdate();
          if (localStorage.getItem("examList").length != 0) {
            let list = JSON.parse(localStorage.getItem("examList"));
            let arr = list;
            for (let i = 0; i < arr.length; i++) {
              if (arr[i].examGrade.id == this.detail.examGrade.id) {
                arr.splice(i, 1);
              }
            }
            localStorage.setItem("examList", JSON.stringify(arr));
          }
          window.onblur = null;
          window.onfocus = null;
          this.submitDialogVisible = false;

          this.signalr.invoke("ClearExam").catch(function (err) {
            return console.error(err.toString());
          });
        })
        .catch((err) => {
          this.submitDialogVisible = false;
          this.$message.error("考试提交失败,请勿关闭考试页面");
          console.warn(err);
        });
    },
    checkAnswer(obj) {
      return obj.fillAnswer == false;
    },
    creatQrCode() {
      //console.warn("creatQrCode");
      let params = JSON.parse(sessionStorage.getItem("faceDetail"));
      // console.warn("params", params);
      if (this.qrCodeModal) {
        return;
      }
      this.qrCodeModal = new QRCode(this.$refs.qrCodeUrl, {
        text: `${sessionStorage.getItem("Link")}/#/rtcHome?Uid=${
          params.examUid
        }&Aid=${params.examArrangeUid}&Key=${params.secretKey}&Name=${
          params.userName
        }&Gid=${params.examGradeUid}`, // 需要转换为二维码的内容
        width: 150,
        height: 150,
        colorDark: "#000000",
        colorLight: "#ffffff",
        correctLevel: QRCode.CorrectLevel.H,
      });
    },
    monitorFace(res) {
      //是否开启人脸识别
      if (res.data.exam.isOpenCameraInvigilate) {
        this.faceDetail = {
          examUid: this.examUid,
          examName: res.data.exam.examName,
          examArrangeUid: res.data.examArrange.id,
          examGradeUid: res.data.examGrade.id,
          beginTimeFormat: res.data.examArrange.beginTime,
          endTimeFormat: res.data.examArrange.endTime,
          examTime: res.data.exam.examTime,
          maxExamNum: res.data.exam.maxExamNum,
          openCameraInvigilateInterval:
            res.data.exam.openCameraInvigilateInterval,
          videoRecordingInterval: res.data.exam.videoRecordingInterval,
          videoRecordingIntervalMax: res.data.exam.videoRecordingIntervalMax,
          isOpenVideoRecording: res.data.exam.isOpenVideoRecording,
        };
        if (res.data.exam.isOpenDoubleMonitoring) {
          this.faceDetail.userId = this.userId;
          this.faceDetail.roomId = this.roomId;
          let _this = this;
          let codeTime = setTimeout(() => {
            this.isBreakOffFace = true;
            //console.warn("暂停timeout");
            _this.pauseExam(_this.examGradeUid);
            _this.pauseTime();
            let codeModal = setTimeout(() => {
              _this.creatQrCode();
              clearTimeout(codeModal);
            }, 500);
            clearTimeout(codeTime);
          }, 5000);
          this.signalr.on("receiveWebRtcMessage", function (res) {
            //console.log(res);
            if (res) {
              //console.warn(_this.isBreakOffFace, "_this.isBreakOffFace");
              _this.isCheckFace = true;
              if (codeTime) {
                clearTimeout(codeTime);
              }
              if (_this.isBreakOffFace) {
                //console.warn("isBreakOffFace");
                let checkTime = setTimeout(() => {
                  _this.continueExam();
                  clearTimeout(checkTime);
                }, 1000);
              }
              _this.$forceUpdate();
            }
          });
          this.signalr.on("receiveOfflineRtcMessage", function (OfflineRes) {
            //console.log("receiveOfflineRtcMessage", OfflineRes);
            _this.isBreakOffFace = true;
            _this.isCheckFace = false;
            let codeItem = setTimeout(() => {
              _this.creatQrCode();
              clearTimeout(codeItem);
            }, 500);
            let _that = _this;
            if (codeTime) {
              clearTimeout(codeTime);
            }
            let time = setTimeout(() => {
              //console.warn("暂停timeout");
              _that.pauseExam(_that.examGradeUid);
              _that.pauseTime();
              clearTimeout(time);
            }, 1000);
            _this.$forceUpdate();
          });
        }
        this.isShowFace = true;
      }
    },
    requestDetail() {
      //console.warn("获取考试详情");
      let joinParams = {};
      if (this.$route.query.examArrangeUid && this.$route.query.examUid) {
        this.examUid = this.$route.query.examUid;
        this.examArrangeUid = this.$route.query.examArrangeUid;
        if (
          this.$route.query.faceVerificationKey &&
          this.$route.query.examGradeUid
        ) {
          joinParams.faceVerificationKey =
            this.$route.query.faceVerificationKey;
          joinParams.examGradeUid = this.$route.query.examGradeUid;
        }
      }
      if (this.$route.query.userId && this.$route.query.roomId) {
        this.userId = this.$route.query.userId;
        this.roomId = this.$route.query.roomId;
      }
      Api.getDetail(this.examUid, this.examArrangeUid, joinParams).then(
        (res) => {
          let params = {
            examGradeUid: res.data.examGrade.id,
            examUid: res.data.examGrade.examUid,
            userId: res.data.userInfo.userUid,
          };
          this.monitorFace(res);
          if (res.data.examGrade.allowExamTime) {
            this.examTime = (res.data.examGrade.allowExamTime / 60).toFixed(1);
          }
          this.getOperationList(params);
          // console.warn("即时通讯状态", this.isConnecting);
          let _this = this;
          if (!this.isConnecting) {
            // console.warn("发送下线消息,ExamLimitMessage");
            let params = {
              ExamUid: res.data.examGrade.examUid,
              ExamArrangeUid: res.data.examGrade.examArrangeUid,
              ExamGradeUid: res.data.examGrade.id,
              IsOpenBook: res.data.exam.isOpenBook,
              ClientType: 0, // 客户端类型  0：Pc   1：移动端
              MethodName: "receiveMessages",
              SourceType: "examing",
              Message: "有新的开卷考试或者已经存在闭卷考试，当前考试即将关闭。",
            };
            //console.warn(JSON.stringify(params));
            //console.warn("_this.detail", res.data);
            this.signalr
              .invoke("ExamLimitMessage", JSON.stringify(params))
              .catch(function (err) {
                return console.error(err.toString());
              });
          } else {
            let _this = this;
            if (res.data.exam.isRealTimeControll) {
              this.isConnectingInterval = setInterval(() => {
                let params = {
                  examGradeUid: res.data.examGrade.id,
                  examUid: res.data.examGrade.examUid,
                  userId: res.data.userInfo.userUid,
                };
                _this.getOperationList(params);
              }, 60000);
            }
          }
          if (res.data.exam.autoSaveToServer) {
            this.autosave = setInterval(() => {
              //console.warn("自动保存");
              this.save("forceSave");
            }, 300000);
            // }, 5000);
          }

          if (!res.data.exam.isOpenBook) {
            this.monitoringScreen(res.data);
          }
          if (res.data.exam.isNoOperationExamSubmit) {
            //console.warn("无操作检测已启用");
            if (res.data.exam.noOperationExamSubmit) {
              this.initMouse(res.data.exam.noOperationExamSubmit); //无操作初始化
            } else {
              console.warn("无操作时间未设置");
            }
          }
          if (res.data.examGrade.allowExamTime != 0) {
            console.warn(
              "res.data.examGrade.allowExamTime",
              res.data.examGrade.allowExamTime
            );

            if (!res.data.examGrade.examTime) {
              this.cutdownTime = res.data.examGrade.allowExamTime * 1000;
            } else {
              this.cutdownTime =
                res.data.examGrade.allowExamTime * 1000 -
                res.data.examGrade.examTime * 1000;
            }
          } else {
            this.cutdownTime = Infinity;
          }
          this.$forceUpdate();
          if (
            localStorage.getItem("examList") &&
            localStorage.getItem("examList").length != 0
          ) {
            let list = JSON.parse(localStorage.getItem("examList"));
            let arr = list;
            for (let i = 0; i < arr.length; i++) {
              if (arr[i].examGrade.id == res.data.examGrade.id) {
                this.detail = arr[i];
                this.showImage();

                this.isExistsDetail = true;
                if (this.detail.examGrade.gradeStatusCode == "pause") {
                  this.pauseDialogVisible = true;
                  this.isPause = true;
                  this.pauseTime();
                  return;
                }
                this.showEditor = true;
                return;
              }
            }
          }
          this.detail = res.data;
          this.showImage();

          this.detail.paperDetail.paperNodes.forEach((item) => {
            item.questions.forEach((subItem) => {
              if (
                subItem.questionBaseTypeCode == "fill" &&
                subItem.standardAnswerCount > 0
              ) {
                subItem.answerText = [];
                for (let i = 0; i < subItem.standardAnswerCount; i++) {
                  let obj = {
                    text: " ",
                  };
                  subItem.answerText.push(obj);
                }
                subItem.fillAnswer = true;
              }
              if (subItem.questionBaseTypeCode == "voice") {
                subItem.voiceType = "";
                subItem.isUpload = false;
              }
              if (subItem.questionBaseTypeCode == "compose") {
                subItem.fillAnswer = true;
                subItem.childQuestions.forEach((childItem) => {
                  if (
                    childItem.questionBaseTypeCode == "fill" &&
                    childItem.standardAnswerCount > 0
                  ) {
                    childItem.answerText = [];
                    for (let i = 0; i < childItem.standardAnswerCount; i++) {
                      let obj = {
                        text: " ",
                      };
                      childItem.answerText.push(obj);
                    }
                    childItem.fillAnswer = true;
                  }
                  if (childItem.questionBaseTypeCode == "voice") {
                    childItem.voiceType = "";
                    childItem.isUpload = false;
                  }
                  if (childItem.questionBaseTypeCode == "answer") {
                    //强行渲染问答题数据 hao
                    this.$set(childItem, "answerText", "");
                  }
                  if (childItem.questionBaseTypeCode == "multi") {
                    childItem.answerText = [];
                    childItem.fillAnswer = true;
                    //console.warn("multiChilditem", childItem.answerText);
                  }
                });
              }
              if (subItem.questionBaseTypeCode == "multi") {
                subItem.answerText = [];
                subItem.fillAnswer = true;
              }
              if (subItem.questionBaseTypeCode == "answer") {
                //强行渲染问答题数据 hao
                this.$set(subItem, "answerText", "");
              }
              if (
                this.detail.examGrade.examGradeAnswer &&
                this.detail.examGrade.examGradeAnswer.examAnswers.length > 0
              ) {
                //console.warn("服务器有保存答案");
                this.detail.examGrade.examGradeAnswer.examAnswers.forEach(
                  (element) => {
                    if (element.questionUid == subItem.id) {
                      if (
                        subItem.questionBaseTypeCode == "fill" &&
                        subItem.standardAnswerCount > 0
                      ) {
                        subItem.answerText = [];
                        for (let i = 0; i < subItem.standardAnswerCount; i++) {
                          let obj = {
                            text: element.answerText,
                          };
                          subItem.answerText.push(obj);
                        }
                      } else if (subItem.questionBaseTypeCode == "multi") {
                        if (element.answerText) {
                          subItem.answerText =
                            element.answerText.split("$contentsplit$");
                        } else {
                          subItem.answerText = [];
                        }
                        subItem.fillAnswer = true;
                      } else {
                        subItem.answerText = element.answerText;
                      }
                      this.$forceUpdate();
                    }
                  }
                );
              }
            });
          });
          this.$forceUpdate();

          this.showEditor = true;
          this.isExistsDetail = true;
          if (this.detail.examGrade.gradeStatusCode == "pause") {
            this.pauseDialogVisible = true;
            this.isPause = true;
            this.pauseTime();
            return;
          }

          console.warn(
            "this.detail.examGrade.allowExamTime",
            this.detail.examGrade.allowExamTime
          );
          if (this.detail.examGrade.allowExamTime != 0) {
            console.warn(
              "this.detail.examGrade.allowExamTime",
              this.detail.examGrade.allowExamTime
            );
            if (!this.detail.examGrade.examTime) {
              this.cutdownTime = this.detail.examGrade.allowExamTime * 1000;
            } else {
              this.cutdownTime =
                this.detail.examGrade.allowExamTime * 1000 -
                this.detail.examGrade.examTime * 1000;
            }
          } else {
            this.cutdownTime = Infinity;
          }
        }
      );
    },
    monitoringScreen(data) {
      let _this = this;
      let num = 0;
      if (sessionStorage.getItem("limitNum")) {
        num = sessionStorage.getItem("limitNum");
      } else {
        sessionStorage.setItem("limitNum", num);
      }
      let oldScreenTime = "";
      let newScreenTime = "";
      let time = null;
      let params = {
        examGradeUid: data.examGrade.id,
      };
      window.onblur = function () {
        document.title = "请继续考试";
        oldScreenTime = new Date().toLocaleString();
        params.beginTime = oldScreenTime;
        // num++;
        time = setTimeout(() => {
          num++;
          console.warn(`切屏${num}次`);
          sessionStorage.setItem("limitNum", num);
        }, data.exam.switchExamPageInterval * 1000);
        console.log(num);
      };
      window.onfocus = function () {
        newScreenTime = new Date().toLocaleString();
        params.endTime = newScreenTime;
        let switchNum = 0;
        // if (num) {
        Api.screen(params)
          .then((res) => {
            console.warn("screen", res);
          })
          .catch((err) => {
            console.warn(err);
          });
        // }
        clearTimeout(time);
        document.title = "正在考试中,请勿离开";
        console.warn(time);
        if (sessionStorage.getItem("limitNum")) {
          num = sessionStorage.getItem("limitNum");
        }
        if (data.exam.isSwitchExamPageCount) {
          switchNum = data.exam.switchExamPageCount;
        } else {
          switchNum = 3;
        }
        if (num < switchNum && num != 0) {
          _this.$message({
            type: "error",
            dangerouslyUseHTMLString: true,
            duration: 5000,
            message: `<strong style="font-size:22px;">已离开当前页面${num}次，离开${switchNum}次将强制交卷</strong>`,
          });
        }
        if (num >= switchNum) {
          if (!this.answerDialogVisible) {
            _this.save("force");
            _this.$message({
              type: "error",
              dangerouslyUseHTMLString: true,
              duration: 5000,
              message: `<strong style="font-size:22px;">由于您离开次数过多，将强制交卷</strong>`,
            });
          }
        }
      };
    },
    getAvatar(blobName) {
      if (!blobName) {
        return;
      }
      axios
        .get(
          `${sessionStorage.getItem(
            "Link"
          )}api/app/file/download-file-system/${blobName}`,
          { responseType: "blob" }
        )
        .then(({ data }) => {
          let blob = new Blob([data]); // 返回的文件流数据
          let url = window.URL.createObjectURL(blob); // 将他转化为路径
          this.imgUrl = url; // 将转换出来的路径赋值给变量，其实和上一步结合就可以
        });
      this.$forceUpdate();
    },
    initMouse(num) {
      //console.warn("启用无操作监听");
      // 监听鼠标
      document.onmousemove = (event) => {
        let x1 = event.clientX;
        let y1 = event.clientY;
        if (this.x !== x1 || this.y !== y1) {
          this.count = 0;
          this.noOperation = false;
          this.cutdownNum = 10;
          clearInterval(this.noOpInterval);
          clearTimeout(this.noOpTimeOut);
          this.noOpTimeOut = null;
          this.noOpInterval = null;
          // this.cutdownNum = this.noOperationCount;
        }
        this.x = x1;
        this.y = y1;
      };
      // 监听键盘
      document.onkeydown = () => {
        this.count = 0;
        this.noOperation = false;
        this.cutdownNum = 10;
        clearInterval(this.noOpInterval);
        clearTimeout(this.noOpTimeOut);
        this.noOpTimeOut = null;
        this.noOpInterval = null;
        // this.cutdownNum = this.noOperationCount;
      };
      // 监听Scroll
      document.onscroll = () => {
        this.count = 0;
        this.noOperation = false;
        this.cutdownNum = 10;
        clearInterval(this.noOpInterval);
        clearTimeout(this.noOpTimeOut);
        this.noOpTimeOut = null;
        this.noOpInterval = null;
        // this.cutdownNum = this.noOperationCount;
      };
      this.setTimer(num);
    },
    clearTimer() {
      clearInterval(window.myTimer);
      window.myTimer = null;
    },
    setTimer(num) {
      this.noOperationCount = num;
      this.count = 0;
      this.cutdownNum = 10;
      clearInterval(this.noOpInterval);
      clearTimeout(this.noOpTimeOut);
      this.noOpTimeOut = null;
      this.noOpInterval = null;
      if (!window.myTimer) {
        //console.warn("进入定时器");
        window.myTimer = window.setInterval(this.cookieTimeout, 1000);
      }
    },
    cookieTimeout() {
      // 判断用户noOperationCount秒无操作就自动登出
      // noOperationCount是秒数
      // let outTime = 5
      //console.warn("进入无操作定时器");
      this.count++;
      //console.warn("count", this.count);
      //console.warn("noOperationCount-10", this.noOperationCount - 10);
      if (this.count >= this.noOperationCount - 10) {
        // if (this.count === outTime * 60) {
        //60
        // this.cutdownNum = 10;
        if (this.noOperation == false) {
          this.noOpTimeOut = setTimeout(
            this.logout(this.noOperationCount),
            10000
          );
          this.noOperation = true;
        }
        // this.$message({
        //   message: `当前已经${this.count}秒内无操作，${this.cutdownNum}秒内无操作将强制交卷，如需继续作答，请任意操作鼠标键盘...`,
        //   type: "error",
        // });
      }
    },
    logout(num) {
      this.noOpInterval = setInterval(() => {
        this.cutdownNum = this.cutdownNum - 1;
        this.$forceUpdate();
        //console.warn("logoutcount", this.count);
        //console.warn("logoutnoOperationCount-10", this.noOperationCount - 10);
        if (this.count >= num) {
          //console.warn("强制交卷");
          this.save("force");
          this.clearTimer();
          clearInterval(this.noOpInterval);
          clearTimeout(this.noOpTimeOut);
        }
      }, 1000);
    },
    $_initData() {
      //console.warn("cutdownTime", this.cutdownTime);
      this.monitorScroll();
      this.requestDetail();
      window.addEventListener("setItem", () => {
        this.isConnecting = JSON.parse(sessionStorage.getItem("isConnecting"));
      });
      this.userInfo = JSON.parse(sessionStorage.getItem("userInfo"));
      if (this.userInfo.extraProperties.Avatar) {
        this.getAvatar(this.userInfo.extraProperties.Avatar);
      }
      document.oncontextmenu = function () {
        return false;
      }; // 禁止右键功能,单击右键将无任何反应
      document.onselectstart = function () {
        return false;
      }; // 禁止先择,也就是无法复制
      let _this = this;
      this.sendMessageToApp();
      // this.signalr
      //   .invoke(
      //     "",
      //     this.userInfo.id,
      //     "发送消息移动端拍侧脸",
      //     "receivePhoneRtcMessage"
      //   )
      //   .catch(function (err) {
      //     return console.error(err.toString());
      //   });
      this.signalr.on("ReceiveSysMsg", function (res) {
        console.log(res);
        let resData = JSON.parse(res);
      });
      this.signalr.on("receiveMessages", function (res) {
        //考试下线
        let resData = JSON.parse(res);
        if (_this.pauseDialogVisible && _this.isPause) {
          _this.$message.error(
            "检测到账号在别处登录,该考试将在五秒后保存并关闭"
          );
          let time = setTimeout(() => {
            clearTimeout(time);
            window.close();
          }, 5000);
          return;
        } else {
          _this.save("forceSave");
          _this.$message.error(
            "检测到账号在别处登录,该考试将在五秒后保存并关闭"
          );
          let time = setTimeout(() => {
            clearTimeout(time);
            window.close();
          }, 5000);
        }
      });
      this.signalr.on("ReceiveExam", function (res) {
        let resData = JSON.parse(res);
        if (resData) {
          if (resData.CommandPara && resData.CommandName != "PauseExam") {
            _this.$message.error(resData.CommandPara);
          }
        }
        //console.warn(resData);
        switch (resData.CommandName) {
          case "ForceToSubmit":
            //console.warn("强行提交");
            _this.updateExamStatus(resData.Id);
            let timee = setTimeout(() => {
              _this.save("force");
              clearTimeout(timee);
            }, 2000);
            break;
          case "PauseExam":
            //console.warn("暂停考试");
            _this.save("forceSave");
            if (resData && resData) {
              _this.isPauseText = resData.CommandPara;
            }

            let _that = _this;
            let time = setTimeout(() => {
              //console.warn("暂停timeout");
              _that.updateExamStatus(resData.Id);
              _that.pauseExam(resData.ExamGradeUid);
              _that.pauseTime();
              clearTimeout(time);
            }, 1000);
            break;
          case "EndPauseExam":
            //console.warn("解除考试暂停");
            _this.updateExamStatus(resData.Id);
            _this.resumeExam(resData.ExamGradeUid);
            _this.continueExam();
            break;
          case "SendMessage":
            _this.updateExamStatus(resData.Id);
            //console.warn("发送消息", resData);
            _this.$alert(resData.CommandPara, "消息通知", {
              confirmButtonText: "确定",
            });
            break;
          case "PushFlow":
            _this.updateExamStatus(resData.Id);
            _this.isPushFlow = true;
            //console.warn("通知推流", resData);
            // _this.$alert(resData.CommandPara, "消息通知", {
            //   confirmButtonText: "确定",
            // });
            break;
          case "CancelPushFlow":
            _this.updateExamStatus(resData.Id);
            _this.isPushFlow = false;
            //console.warn("通知取消推流", resData);
            // _this.$alert(resData.CommandPara, "消息通知", {
            //   confirmButtonText: "确定",
            // });
            break;
        }
      });
    },
    monitorScroll() {
      console.warn("scroll");
      window.addEventListener("scroll", this.handleScroll, true);
    },
    handleScroll() {
      let scrollY = window.scrollY;
      let scrollObj = document.querySelector(".main-right");
      let scrollObj1 = document.querySelector(".headers-nav");
      let scrollCardObj = document.querySelector(".answers-card");
      let scrollCardModalObj = document.querySelector(".card-modal");
      let scrollFaceObj = document.querySelector(".examFaceModal");

      let width = this.rightWidth;
      if (scrollY > 250) {
        scrollObj1.style.position = "fixed";
        scrollObj1.style.margin = "0 auto";
        scrollObj1.style.left = "0";
        scrollObj1.style.right = "0";
        scrollObj1.style.top = "0";
        scrollObj1.style.zIndex = "999";
        scrollObj.style.position = "fixed";
        scrollObj.style.right = width + "px";
        scrollObj.style.top = "126px";
        // console.warn("scroll", scrollCardObj.style);
        if (
          this.$refs["answers-card"] &&
          this.$refs["answers-card"].offsetHeight
        ) {
          scrollCardObj.style.height = "700px";
          // scrollCardObj.style["overflow-y"] = "scroll";
          scrollCardModalObj.style.overflow = "scroll";
          scrollCardModalObj.style.height = "100%";
          scrollCardModalObj.style["padding-bottom"] = "100px";
          // this.$refs['answers-card'].height = '650px'
        }
        if (scrollFaceObj) {
          // scrollFaceObj.style.position = "fixed";
          // scrollFaceObj.style.right = width + "px";
          // scrollFaceObj.style.top = "30px";
        }
        // let height= this.$refs.element.offsetHeight;  //100

        this.isShowTop = true;
      } else {
        this.isShowTop = false;
        scrollObj.style.position = "absolute";
        scrollObj.style.top = "0";
        scrollObj.style.right = "0";
        scrollObj1.style.position = "absolute";
        scrollObj1.style.bottom = "0";
        scrollObj1.style.top = "auto";
        if (scrollFaceObj) {
          scrollFaceObj.style.position = "relative";
          scrollFaceObj.style.marginTop = "0";
        }
      }
    },
    httpequest(data) {
      // console.log(data);
      // console.log(this.detail.paperDetail.paperNodes,'---------------------',this.detail.paperDetail.paperNodes.questions);

      let testmsg = data.file.name.substring(
        data.file.name.lastIndexOf(".") + 1
      );
      // console.log(testmsg);
      const extension = testmsg === "xls";

      const extension2 = testmsg === "xlsx";

      const extension3 = testmsg === "txt";

      const extension4 = testmsg === "docx";

      const extension5 = testmsg === "json";
      if (
        !extension &&
        !extension2 &&
        !extension3 &&
        !extension4 &&
        !extension5
      ) {
        this.$message({
          message: "上传文件只能是 xls、xlsx、txt、docx格式!",

          type: "warning",
        });
      } else {
        let formData = new FormData();

        formData.append("file", data.file);

        axios.post(`/api/app/file/upload-file-system`, formData).then((res) => {
          this.editorResList.push(res);
          console.log(res);
          this.detail.paperDetail.paperNodes.forEach((i) => {
            if (i.questions[0].id == this.getAvID) {
              i.questions[0].answerText = i.questions[0].answerText.replace(
                /<span style="font-weight: normal;">/g,
                ""
              );
              i.questions[0].answerText = i.questions[0].answerText.replace(
                /<\/span>/g,
                ""
              );
              i.questions[0].answerText = i.questions[0].answerText.replace(
                i.questions[0].answerText,
                `<p>${i.questions[0].answerText}</p>`
              );

              i.questions[0].answerText =
                i.questions[0].answerText.replace(/(?:^<p>)|(?:<\/p>)$/gi, "") +
                `<a target="_blank" href=${res.data.fileServerUrl}>${res.data.fileName} </a>`;
            }
          });
        });
      }
    },
    getId(av) {
      console.log(av);
      this.getAvID = av;
    },
    editorSubItem(av) {
      this.getAvIDBB = av;
      // console.log(av)
      // let arr = document.getElementsByClassName('getEdiotr')

      // 上传的文件数组
      let innerHTMLList = this.detail.paperDetail.paperNodes;
      // console.log(this.editorResList);
      for (let o = 0; o < innerHTMLList.length; o++) {
        for (let i = 0; i < this.editorResList.length; i++) {
          // console.log(this.editorResList[i].data.fileServerUrl);
          // console.log(this.detail.paperDetail.paperNodes[o].questions[0]);
          if (
            this.detail.paperDetail.paperNodes[o].questions[0].id ==
            this.getAvIDBB
          ) {
            // console.log(this.detail.paperDetail.paperNodes[o].questions[0].answerText);
            // console.log(this.detail.paperDetail.paperNodes[o].questions[0].answerText.includes(this.editorResList[i].data.fileServerUrl))
            // console.log(this.detail.paperDetail.paperNodes[o].questions[0].answerText.includes(this.editorResList[i].data.fileName));
            if (
              this.detail.paperDetail.paperNodes[
                o
              ].questions[0].answerText.includes(
                this.editorResList[i].data.fileServerUrl
              ) &&
              !this.detail.paperDetail.paperNodes[
                o
              ].questions[0].answerText.includes(
                this.editorResList[i].data.fileName
              )
            ) {
              //console.log(32423423423);
              this.detail.paperDetail.paperNodes[o].questions[0].answerText =
                this.detail.paperDetail.paperNodes[
                  o
                ].questions[0].answerText.replace(
                  `<a target="_blank" href="${this.editorResList[i].data.fileServerUrl}">`,
                  ""
                );
              console.log(
                this.detail.paperDetail.paperNodes[o].questions[0].answerText
              );
            }
          }
          //    this.detail.paperDetail.paperNodes.forEach(i=>{
          //            for(let item = 0;i<this.detail.paperDetail.paperNodes.length;item++){
          //           if(this.detail.paperDetail.paperNodes[item].questions[0].id == this.getAvIDBB){
          //           console.log( this.detail.paperDetail.paperNodes[item].questions[0].answerText);
          //         //   this.editorResList[i].data.fileServerUrl
          //         console.log(this.editorResList[i].data.fileServerUrl);
          //           console.log( this.detail.paperDetail.paperNodes[item].questions[0].answerText.includes(this.editorResList[item].data.fileServerUrl))

          // }
          //            }

          // })
        }
      }
      //  console.log(this.editorResList[0]);
    },
    showImage() {
      setTimeout(() => {
        let b = document.getElementsByTagName("img");
        // console.log(b);
        let arrImg = Array.from(b);
        //   console.log(arrImg);
        arrImg.forEach((i) => {
          //console.log(i.currentSrc);
          if (i.currentSrc.includes("/api/app/file/download-file-byblob")) {
            i.style.maxHeight = "100px";
            i.style.maxWidth = "";
            let modal = document.getElementById("myModal");

            let modalImg = document.getElementById("img01");
            //   console.log(i);
            //        i.addEventListener("click",function(){

            //     console.log("my",i);
            // });
            i.onclick = function () {
              console.log(1, this, "-----", this.src, i.style, i);

              modal.style.display = "flex";
              modalImg.src = this.src;
            };
            let span = document.getElementsByClassName("close")[0];
            span.onclick = function () {
              modal.style.display = "none";
            };
          }
        });
      }, 2000);
    },
    RandomRange(min, max) {
      min = min || 500;
      max = max || 3001;
      return Math.floor(Math.random() * (3001 - min + 1) + min);
    },
    AudioControlOperation(interval) {
      const controls = document.querySelectorAll("audio");
      let that = this;
      //console.log("controls", controls);
      if (!controls || controls.length == 0) {
        console.log(
          "未获取到标签:" +
            (interval > 0 &&
              this.AudioControlOperationCount <
                this.AudioControlOperationMaxCount)
        );
        if (
          interval > 0 &&
          this.AudioControlOperationCount < this.AudioControlOperationMaxCount
        ) {
          this.AudioControlOperationCount += 1;
          console.log(
            "音频查找尝试第" + this.AudioControlOperationCount + "次"
          );
          setTimeout(function () {
            that.AudioControlOperation(interval);
          }, interval);
        }
        return;
      }

      for (let i = 0; i < controls.length; i++) {
        controls[i].RetryCount = 0;
        controls[i].addEventListener("error", (event) => {
          if (event.target.RetryCount < this.canplayMaxRetries) {
            event.target.RetryCount += 1;
            //event.target.src=event.target.src;
            setTimeout(() => {
              //event.target.load();
              event.target.src =
                event.target.src.replace(/\?t=\d+?$/gi, "") +
                "?t=" +
                +new Date();
              console.log(
                "音频资源加载第" + event.target.RetryCount + "次重试"
              );
            }, that.RandomRange());
          } else {
            console.log("音频资源加载" + event.target.RetryCount + "失败");
          }
        });
      }
    },
  },
  mounted() {
    this.$_initData();
    //console.warn("测试页面是否更新成功");
    // this.initRecord();
    //创建方法，用于服务端调用
    let that = this;
    setTimeout(function () {
      that.AudioControlOperation(1000);
    }, 1000);
  },
  beforeDestroy() {
    this.clearTimer();
  },
  destroyed() {
    this.dialogVisible = false;
    this.answerDialogVisible = false;
    this.isShowFace = false;
    window.onblur = null;
    window.onfocus = null;
    this.clearAutosave();
    window.removeEventListener("scroll", this.handleScroll); //页面离开后销毁监听事件
    sessionStorage.setItem("limitNum", 0);
    this.detail.paperDetail.paperNodes.forEach((item) => {
      item.questions.forEach((subItem) => {
        if (subItem.questionBaseTypeCode == "voice") {
          subItem.isRecord = false;
        }
        if (subItem.questionBaseTypeCode == "compose") {
          subItem.childQuestions.forEach((childItem) => {
            if (childItem.questionBaseTypeCode == "voice") {
              childItem.isRecord = false;
            }
          });
        }
      });
      if (localStorage.getItem("examList")) {
        console.warn("有缓存");
        let list = JSON.parse(localStorage.getItem("examList"));
        if (list.length == 0) {
          let arr = [];
          arr.push(this.detail);
          localStorage.setItem("examList", JSON.stringify(arr));
        } else {
          let arr = list;
          let isHave = false;
          for (let i = 0; i < arr.length; i++) {
            if (arr[i].examGrade.id == this.detail.examGrade.id) {
              arr[i] = this.detail;
              isHave = true;
              break;
            }
          }
          if (!isHave) {
            arr.push(this.detail);
          }
          localStorage.setItem("examList", JSON.stringify(arr));
        }
      } else {
        console.warn("无缓存");
        let arr = [];
        arr.push(this.detail);
        localStorage.setItem("examList", JSON.stringify(arr));
      }
    });
    if (sessionStorage.getItem("cutdownTime")) {
      sessionStorage.removeItem("cutdownTime");
    }
    document.removeEventListener("onblur", () => {
      console.log("销毁页面隐藏");
    });
    document.removeEventListener("onfocus", () => {
      console.log("销毁页面隐藏");
    });
  },
  computed: {
    rightWidth() {
      let num = (document.body.clientWidth - 1300) / 2;
      return num;
    },
  },
  watch: {
    detail: {
      handler(newVal, oldVal) {
        newVal.paperDetail.paperNodes.forEach((item) => {
          item.questions.forEach((subItem) => {
            if (subItem.questionBaseTypeCode == "compose") {
              subItem.childQuestions.forEach((element) => {
                if (element.questionBaseTypeCode == "fill") {
                  if (element.answerText.every(this.checkValue)) {
                    element.fillAnswer = false;
                  } else {
                    element.fillAnswer = true;
                    this.$forceUpdate();
                  }
                } else if (element.answerText) {
                  if (Array.isArray(element.answerText)) {
                    if (element.answerText.length == 0) {
                      element.fillAnswer = true;
                    }
                  } else {
                    element.fillAnswer = false;
                    this.$forceUpdate();
                  }
                } else {
                  element.fillAnswer = true;
                }
              });
              if (subItem.childQuestions.every(this.checkAnswer)) {
                subItem.fillAnswer = false;
                this.$forceUpdate();
              }
            }
            if (
              subItem.questionBaseTypeCode != "compose" &&
              subItem.questionBaseTypeCode != "fill"
            ) {
              if (subItem.answerText) {
                if (Array.isArray(subItem.answerText)) {
                  if (subItem.answerText.length == 0) {
                    subItem.fillAnswer = true;
                  } else {
                    subItem.fillAnswer = false;
                    this.$forceUpdate();
                  }
                } else {
                  subItem.fillAnswer = false;
                  this.$forceUpdate();
                }
              } else if (subItem.isUpload) {
                subItem.fillAnswer = false;
              } else {
                subItem.fillAnswer = true;
              }
              // if (subItem.questionBaseTypeCode == 'voice') {
              //     if (subItem.isUpload) {
              //         subItem.fillAnswer = false;
              //     }
              // }
            }
          });
        });
        if (this.changeLoading) {
          return;
        }

        let newDetail = JSON.parse(JSON.stringify(newVal));
        newDetail.paperDetail.paperNodes.forEach((item) => {
          item.questions.forEach((subItem) => {
            if (subItem.questionBaseTypeCode == "compose") {
              subItem.childQuestions.forEach((element) => {
                if (element.questionBaseTypeCode == "voice") {
                  element.recorder = null;
                }
              });
            }
            if (subItem.questionBaseTypeCode == "voice") {
              subItem.recorder = null;
            }
          });
        });
        if (localStorage.getItem("examList")) {
          console.warn("有缓存");
          let list = JSON.parse(localStorage.getItem("examList"));
          if (list.length == 0) {
            let arr = [];
            arr.push(newDetail);
            localStorage.setItem("examList", JSON.stringify(arr));
          } else {
            let arr = list;
            let isHave = false;
            for (let i = 0; i < arr.length; i++) {
              if (arr[i].examGrade.id == newDetail.examGrade.id) {
                arr[i] = newDetail;
                isHave = true;
                break;
              }
            }
            if (!isHave) {
              arr.push(newDetail);
            }
            localStorage.setItem("examList", JSON.stringify(arr));
          }
        } else {
          console.warn("无缓存");
          let arr = [];
          arr.push(newDetail);
          localStorage.setItem("examList", JSON.stringify(arr));
        }
      },
      // 开启深度监听：只要obj中的任何一个属性发生改变，都会触发相应的代码
      deep: true,
    },
    isConnecting: {
      handler(newVal, oldVal) {
        if (newVal == true) {
          let _this = this;
          console.warn("isConnecting", "链接中断或者重连", this.isConnecting);
          if (_this.detail.exam.isRealTimeControll) {
            this.isConnectingInterval = setInterval(() => {
              let params = {
                examGradeUid: _this.detail.examGrade.id,
                examUid: _this.detail.examGrade.examUid,
                userId: _this.detail.userInfo.userUid,
              };
              _this.getOperationList(params);
            }, 60000);
          }
        } else {
          let _this = this;
          clearInterval(this.isConnectingInterval);
          if (this.isExistsDetail == true) {
            console.warn("发送下线消息,watch");
            let params = {
              ExamUid: _this.detail.examGrade.examUid,
              ExamArrangeUid: _this.detail.examGrade.examArrangeUid,
              ExamGradeUid: _this.detail.examGrade.id,
              IsOpenBook: _this.detail.exam.isOpenBook,
              ClientType: 0, // 客户端类型  0：Pc   1：移动端
              MethodName: "receiveMessages",
              SourceType: "examing",
              Message: "有新的开卷考试或者已经存在闭卷考试，当前考试即将关闭。",
            };
            console.warn(JSON.stringify(params));
            console.warn("_this.detail", _this.detail);
            this.signalr
              .invoke("ExamLimitMessage", JSON.stringify(params))
              .catch(function (err) {
                return console.error(err.toString());
              });
          }
        }
      },
    },
  },
};
</script>

<style lang="scss" scoped>
//字体大小定义
$font_size_10: 10px;
$font_size_12: 12px;
$font_size_14: 14px;
$font_size_16: 16px;
.showSave {
  color: red;
  margin-right: 160px;
}

.hidden {
  visibility: hidden;
  opacity: 0;
  transition: visibility 0s 2s, opacity 2s linear;
}

::v-deep .el-dialog {
  border-radius: 13px;
}
::v-deep .el-dialog.off-face-modal {
  z-index: 9999;
  position: relative;
  background: #ffffff;
  border-radius: 13px;
  box-shadow: 0px 2px 29px 0px rgba(0, 0, 0, 0.03);
  width: 506px !important;
  height: 412px;
  .face-modal-content {
    .face-title {
      font-size: 26px;
      font-family: Source Han Sans CN, Source Han Sans CN-Bold;
      font-weight: 700;
      text-align: center;
      color: #161616;
      line-height: 60px;
      letter-spacing: 2.08px;
    }
    .face-tips {
      font-size: 16px;
      font-family: Microsoft YaHei, Microsoft YaHei-Regular;
      font-weight: 400;
      text-align: center;
      color: #656565;
      line-height: 24px;
    }
    .face-code {
      display: flex;
      justify-content: center;
      margin: 12px auto;
    }
    .code-tips {
      width: 150px;
      margin: 0 auto;
      font-size: 16px;
      line-height: 32px;
      font-weight: 400;
      text-align: center;
      color: #fa6a67;
      position: relative;
      padding-left: 10px;
      &::before {
        content: "";
        width: 16px;
        height: 16px;
        border-radius: 50%;
        position: absolute;
        // top: 6px;
        top: 50%;
        transform: translateY(-50%);
        left: -10px;
      }
    }
    .success {
      color: #44d7b6;
      &::before {
        background: rgba(68, 215, 182, 0.7);
      }
    }
    .error {
      color: #fa6a67;
      &::before {
        background: rgba(250, 106, 103, 0.7);
      }
    }
  }
}
::v-deep .node-question-content {
  img {
   /* height: 50px !important;*/
    width: auto !important;
    object-fit: contain;
  }
}

.modal {
  display: none;
  position: fixed;
  z-index: 1;
  left: 0;
  top: 0;
  width: 100%;
  height: 100%;
  padding-top: 50px;
  overflow: auto;
  background-color: rgb(0, 0, 0);
  background-color: rgba(0, 0, 0, 0.85);
  align-items: center;
  justify-content: center;
  .modal-content {
    margin: auto;
    display: block;
    width: 100%;
    max-width: 500px;
    // margin-top: 38%;
  }
}

#caption {
  margin: auto;
  display: block;
  width: 80%;
  max-width: 700px;
  text-align: center;
  color: #ccc;
  padding: 10px 0;
  height: 150px;
}
.modal-content,
#caption {
  -webkit-animation: zoom 0.6s;
  -o-animation: zoom 0.6s;
  animation: zoom 0.6s;
}
@-webkit-keyframes zoom {
  from {
    -webkit-transform: scale(0.1);
  }
  to {
    -webkit-transform: scale(1);
  }
}
@keyframes zoom {
  from {
    transform: scale(0.1);
  }
  to {
    transform: scale(1);
  }
}

.close {
  position: absolute;
  top: 15px;
  right: 35px;
  color: #f1f1f1;
  font-size: 40px;
  font-weight: bold;
  transition: 0.3s;
}
.close:hover,
.close:focus {
  color: #bbb;
  text-decoration: none;
  cursor: pointer;
}
/* 100% Image Width on Smaller Screens */
@media only screen and (max-width: 700px) {
  .modal-content {
    width: 100%;
  }
}
.examFaceModal {
  // position: fixed;
  width: 386px;
  //   height: 350px;
  margin-bottom: 16px;
  // left: 50px;
  // top: 30px;
  // width: 300px;
  // height: 250px;
}
.exam {
  // overflow-y: scroll;
  min-height: 1200px;
  padding-bottom: 50px;
  width: 100%;
  background: url("./../../assets/exam/exam-bg.jpg");
  background-size: cover;
  .voice-content {
    audio {
      width: 374px !important;
      height: 50px !important;
    }
  }
  .voice-btn {
    width: 122px;
    height: 36px;
    margin-right: 12px;
  }
  .voice-answer {
    width: 374px;
    height: 50px;
    background: #f1f3f4;
    border-radius: 25px;
    display: flex;
    align-items: center;
    justify-content: center;
    font-size: 16px;
    font-weight: 400;
    color: #999999;
  }
  .disable {
    pointer-events: none;
  }
  .el-radio {
    display: flex;
    align-items: center;
  }
  ::v-deep .el-radio__label {
    display: inline-flex;
    align-items: center;
  }
  .el-checkbox {
    display: flex;
    align-items: center;
  }
  ::v-deep .el-checkbox__label {
    display: inline-flex;
    align-items: center;
  }
  .el-dialog__header {
    padding: 0;
  }
  .no-header-modal {
    padding: 20px 20px 10px;
  }
  .el-card__body {
    padding: 32px 46px;
  }
  .mg-rt {
    margin-right: 8px;
  }
  .el-input__inner {
    border: none !important;
  }
  .el-textarea {
    width: 70% !important;
  }
  .el-textarea__inner {
    border: none !important;
  }
  padding-top: 44px;
  background-color: #fff;
  .exam-header {
    position: relative;
    margin: 0 auto;
    margin-bottom: 24px;
    width: 1300px;
    height: 300px;
    .header-detail {
      width: 100%;
      height: 256px;
      position: relative;
      img {
        position: absolute;
        top: 0;
        width: 100%;
        height: 100%;
      }
      .paper-headr {
        left: 70px;
        top: 45px;
        position: relative;
        .exam-center {
          font-size: 14px;
          font-weight: 500;
          text-align: left;
          color: #ffffff;
          line-height: 22px;
          margin-bottom: 15px;
        }
        .paper-name {
          font-size: 32px;
          font-weight: 600;
          text-align: left;
          color: #ffffff;
          line-height: 36px;
          margin-bottom: 30px;
        }
        .paper-message {
          font-size: 12px;
          background: #f5f5f5;
          border-radius: 12px;
          display: flex;
          position: absolute;
          padding: 5px 20px;
          .label {
            font-weight: 400;
            text-align: left;
            color: #999999;
            line-height: 17px;
          }
        }
      }
    }
    .headers-nav {
      position: absolute;
      bottom: 0;
      height: 94px;
      width: 1300px;
      background: linear-gradient(
        136deg,
        rgba(255, 255, 255, 0.82),
        rgba(255, 255, 255, 0.8) 100%
      );
      border-radius: 15px;
      box-shadow: 0px 2px 5px 0px rgba(0, 0, 0, 0.02);
      backdrop-filter: blur(8px);
      display: flex;
      align-items: center;
      .font-select {
        display: flex;
        width: 280px;
        justify-content: space-between;
        align-items: center;
        height: 30px;
        padding-right: 8px;
        padding-left: 15px;
        margin-left: 120px;
        .select-text {
          font-size: 16px;
          font-weight: 500;
          text-align: center;
          color: #666666;
          line-height: 15px;
          text-shadow: 0px 2px 5px 0px rgba(0, 0, 0, 0.06);
        }
      }
      .normal {
        width: 100%;
        display: flex;
        padding-left: 65px;
        align-items: center;
        justify-content: space-between;
        .user-detail {
          display: flex;
          align-items: center;
          .user-right {
            margin-left: 28px;
            .user-name {
              font-size: 18px;
              font-weight: 600;
              text-align: left;
              color: #1e2046;
              line-height: 25px;
              margin-bottom: 8px;
            }
            .user-code {
              font-size: 14px;
              font-weight: 400;
              text-align: left;
              color: #666666;
              line-height: 20px;
            }
          }
          img {
            height: 65px;
            width: 65px;
            border-radius: 50%;
          }
        }
        .nav-right {
          align-items: center;
          display: flex;
          padding-right: 32px;
          .font-select {
            display: flex;
            width: 280px;
            justify-content: space-between;
            align-items: center;
            height: 30px;
            padding-right: 8px;
            .select-text {
              font-size: 16px;
              font-weight: 500;
              text-align: center;
              color: #666666;
              line-height: 15px;
              text-shadow: 0px 2px 5px 0px rgba(0, 0, 0, 0.06);
            }
          }
          .operate-btn {
            align-items: center;
            display: flex;
            .exam-btn {
              align-items: center;
              display: flex;
              cursor: pointer;
            }
          }
        }
      }
      .small {
        width: 1300px;
        margin: 0 auto;
        height: 100%;
        display: -webkit-box;
        display: -ms-flexbox;
        display: flex;
        padding-left: 65px;
        -webkit-box-align: center;
        -ms-flex-align: center;
        align-items: center;
        -ms-flex-pack: justify;
        justify-content: space-between;
        .user-detail {
          height: 100%;
          .detail-top {
            height: 50%;
            font-size: 18px;
            font-weight: 700;
            text-align: left;
            color: #1e2046;
            line-height: 25px;
            padding-top: 17px;
          }
          .detail-bottom {
            padding-bottom: 10px;
            height: 50%;
            display: flex;
            align-items: center;
            img {
              width: 25px;
              height: 26px;
              border-radius: 50%;
              margin-right: 10px;
            }
            .user-name {
              font-size: 14px;
              font-weight: 400;
              text-align: left;
              color: #666666;
              line-height: 20px;
              margin-right: 14px;
            }
            .user-code {
              font-size: 14px;
              font-weight: 400;
              text-align: left;
              color: #666666;
              line-height: 20px;
            }
            .paper-message {
              font-size: 12px;
              background: #f5f5f5;
              border-radius: 12px;
              display: flex;
              padding: 5px 20px;
              margin-left: 16px;
              .label {
                font-weight: 400;
                text-align: left;
                color: #999999;
                line-height: 17px;
              }
            }
          }
        }
        .nav-right {
          align-items: center;
          display: flex;
          padding-right: 32px;
          .font-select {
            display: flex;
            width: 280px;
            justify-content: space-between;
            align-items: center;
            height: 30px;
            padding-right: 8px;
            .select-text {
              font-size: 16px;
              font-weight: 500;
              text-align: center;
              color: #666666;
              line-height: 15px;
              text-shadow: 0px 2px 5px 0px rgba(0, 0, 0, 0.06);
            }
          }
          .operate-btn {
            align-items: center;
            display: flex;
            .exam-btn {
              align-items: center;
              display: flex;
              cursor: pointer;
            }
          }
        }
      }
    }
  }
  .exam-main {
    position: relative;
    margin: 0 auto;
    width: 1300px;
    .example-item {
      display: flex;
      align-items: center;
      justify-content: center;
      position: relative;
      .item-content {
        border: 1px solid #e5e5e5;
        margin: 6px 0;
        padding: 3px;
        display: flex;
        align-items: center;
        justify-content: center;
        width: 16px;
        height: 16px;
      }
      .corner {
        position: absolute;
        right: -5px;
        width: 0;
        height: 0;
        top: 1px;
        border: 5px solid #e5e5e5;
        border-bottom-color: transparent;
        border-top-color: transparent;
        border-left-color: transparent;
        transform: rotateZ(135deg);
      }
      &.finish {
        .corner {
          position: absolute;
          right: -5px;
          width: 0;
          height: 0;
          top: 1px;
          border: 5px solid #1890ff;
          border-bottom-color: transparent;
          border-top-color: transparent;
          border-left-color: transparent;
          transform: rotateZ(135deg);
        }
        .item-content {
          border: 1px solid #1890ff;
          color: #fff;
          .item-centre {
            background-color: #1890ff;
            display: flex;
            align-items: center;
            justify-content: center;
            width: 100%;
            height: 100%;
          }
        }
      }
    }
    .com-item {
      display: flex;
      align-items: center;
      justify-content: center;
      position: relative;
      .item-content {
        border: 1px solid #e5e5e5;
        margin: 6px 0;
        padding: 3px;
        display: flex;
        align-items: center;
        justify-content: center;
        width: 16px;
        height: 16px;
      }
      .corner {
        position: absolute;
        right: -5px;
        width: 0;
        height: 0;
        top: 1px;
        border: 5px solid #e5e5e5;
        border-bottom-color: transparent;
        border-top-color: transparent;
        border-left-color: transparent;
        transform: rotateZ(135deg);
      }
      &.finish {
        .corner {
          position: absolute;
          right: -5px;
          width: 0;
          height: 0;
          top: 1px;
          border: 5px solid #44d7b6;
          border-bottom-color: transparent;
          border-top-color: transparent;
          border-left-color: transparent;
          transform: rotateZ(135deg);
        }
        .item-content {
          border: 1px solid #44d7b6;
          color: #fff;
          .item-centre {
            background-color: #44d7b6;
            display: flex;
            align-items: center;
            justify-content: center;
            width: 100%;
            height: 100%;
          }
        }
      }
    }
    // margin-top: 40px;
    // height: 1000px;
    .main-left {
      width: 890px;
      height: 100%;
      background: linear-gradient(
        136deg,
        rgba(255, 255, 255, 0.82),
        rgba(255, 255, 255, 0.8) 100%
      );
      border-radius: 15px;
      box-shadow: 0px 2px 5px 0px rgba(0, 0, 0, 0.04);
      backdrop-filter: blur(8px);
      overflow: hidden;
      padding: 32px 46px;
      .sign-tips {
        font-size: 14px;
        font-weight: 400;
        text-align: left;
        color: #999999;
        line-height: 25px;
        display: flex;
        align-items: center;
        // margin-bottom: 16px;
      }
      .paper-detail {
        margin-top: 16px;
        .node-head {
          font-size: 22px;
          font-weight: 600;
          text-align: left;
          color: #2d3748;
          line-height: 25px;
          .tips {
            font-size: 14px;
            font-weight: 400;
            text-align: left;
            color: #999999;
            line-height: 25px;
          }
        }
        .node-content {
          //   margin-top: 16px;
          .node-question {
            // margin-bottom: 12px;
            padding: 16px 0 0 0;
            p {
              margin: 0 !important;
            }
            .exam-input {
              width: 100px;
              min-width: 100px;
              border: none;
              outline: none;
              border-bottom: 1px solid #000;
            }
            .node-question-title {
              font-size: 14px;
              font-weight: 500;
              text-align: left;
              color: #333333;
              line-height: 20px;
              padding-left: 16px;
              font-weight: 600;
              p {
                font-size: 14px;
                font-weight: 500;
                text-align: left;
                color: #333333;
                line-height: 20px;
              }
              .tips {
                font-size: 14px;
                font-weight: 400;
                text-align: left;
                color: #999999;
                line-height: 25px;
                margin-left: 8px;
              }
              .node-qusetion-typeName {
                padding: 3px 8px;
                min-width: 40px;
                max-width: 80px;
                height: 22px;
                background: #f5f5f5;
                border-radius: 3px;
                font-size: 12px;
                font-weight: 400;
                color: #333333;
                margin-left: 16px;
                margin-right: 10px;
                line-height: 17px;
                &.select {
                  color: #fff !important;
                  background-color: #1890ff !important;
                  border-color: #1890ff !important;
                }
              }
            }
            .node-question-content {
              display: flex;
              padding: 4px 0 4px 16px;
              align-items: center;
              min-height: 34px;
              audio {
                height: 40px !important;
              }
              img {
                height: 50px !important;
                width: auto !important;
                object-fit: contain;
              }
            }
            .node-question-answers {
              padding: 4px 0 4px 16px;
              align-items: center;
              font-size: 16px;
              font-weight: 600;
            }
          }
        }
      }
      &.normal {
        .sign-tips {
          font-size: $font_size_14;
        }
        .node-question-content {
          .text {
            font-size: $font_size_14 !important;
          }
        }
        .paper-detail {
          .node-head {
            font-size: $font_size_10 * 2.2;
            .tips {
              font-size: $font_size_14;
            }
          }
          .node-content {
            .node-question {
              .node-question-title {
                font-size: $font_size_14;
                line-height: $font_size_14 * 2;
                p {
                  font-size: $font_size_14;
                }
                .tips {
                  font-size: $font_size_14;
                }
                .node-qusetion-typeName {
                  font-size: $font_size_12;
                }

                .node-question-answers {
                  font-size: $font_size_16;
                }
              }
            }
          }
        }
      }
      &.center {
        .node-question-content {
          .text {
            font-size: $font_size_16 !important;
          }
        }
        ::v-deep .el-radio__label {
          font-size: $font_size_16 !important;
        }
        .sign-tips {
          font-size: $font_size_16;
        }
        .paper-detail {
          .node-head {
            font-size: $font_size_10 * 2.4;
            .tips {
              font-size: $font_size_16;
            }
          }
          .node-content {
            .node-question {
              .node-question-title {
                font-size: $font_size_16;
                line-height: $font_size_16 * 2;
                p {
                  font-size: $font_size_16;
                }
                .tips {
                  font-size: $font_size_16;
                }
                .node-qusetion-typeName {
                  font-size: $font_size_14;
                }

                .node-question-answers {
                  font-size: $font_size_14;
                }
              }
            }
          }
        }
      }
      &.big {
        .node-question-content {
          .text {
            font-size: $font_size_10 * 1.8 !important;
          }
        }
        ::v-deep .el-radio__label {
          font-size: $font_size_10 * 1.8 !important;
        }
        .sign-tips {
          font-size: $font_size_10 * 1.8;
        }
        .paper-detail {
          .node-head {
            font-size: $font_size_10 * 2.6;
            .tips {
              font-size: $font_size_10 * 1.8;
            }
          }
          .node-content {
            .node-question {
              .node-question-title {
                font-size: $font_size_10 * 1.8;
                line-height: $font_size_10 * 1.8 * 2;
                p {
                  font-size: $font_size_10 * 1.8;
                }
                .tips {
                  font-size: $font_size_10 * 1.8;
                }
                .node-qusetion-typeName {
                  font-size: $font_size_16;
                }

                .node-question-answers {
                  font-size: $font_size_16;
                }
              }
            }
          }
        }
      }
      &.oversized {
        .node-question-content {
          .text {
            font-size: $font_size_10 * 2 !important;
          }
        }
        ::v-deep .el-radio__label {
          font-size: $font_size_10 * 2 !important;
        }
        .sign-tips {
          font-size: $font_size_10 * 2;
        }
        .paper-detail {
          .node-head {
            font-size: $font_size_10 * 2.8;
            .tips {
              font-size: $font_size_10 * 2;
            }
          }
          .node-content {
            .node-question {
              .node-question-title {
                font-size: $font_size_10 * 2;
                line-height: $font_size_10 * 4;
                p {
                  font-size: $font_size_10 * 2;
                }
                .tips {
                  font-size: $font_size_10 * 2;
                }
                .node-qusetion-typeName {
                  font-size: $font_size_10 * 1.8;
                }

                .node-question-answers {
                  font-size: $font_size_10 * 1.8;
                }
              }
            }
          }
        }
      }
    }
    .main-right {
      width: 386px;
      position: absolute;
      right: 0;
      .time-remaining {
        height: 77px;
        justify-content: space-between;
        display: flex;
        background-color: #f2f2f2;
        border-radius: 15px;
        align-items: center;
        padding: 0 16px;
        margin-bottom: 24px;
        background: linear-gradient(
          136deg,
          rgba(255, 255, 255, 0.82),
          rgba(255, 255, 255, 0.8) 100%
        );
        border-radius: 15px;
        box-shadow: 0px 2px 5px 0px rgba(0, 0, 0, 0.02);
        backdrop-filter: blur(8px);
        font-size: 16px;
        font-weight: 400;
        text-align: left;
        color: #000000;
        .block {
          font-size: 30px;
          font-weight: 500;
          text-align: left;
          color: #1fa3ff;
          line-height: 42px;
        }
      }
      .answers-card {
        border-radius: 15px;
        width: 386px;
        overflow: hidden;
        background: linear-gradient(
          136deg,
          rgba(255, 255, 255, 0.82),
          rgba(255, 255, 255, 0.8) 100%
        );
        border-radius: 15px;
        box-shadow: 0px 2px 5px 0px rgba(0, 0, 0, 0.02);
        backdrop-filter: blur(8px);
        padding-bottom: 8px;
        font-size: 12px;
        font-weight: 500;
        color: #9b9b9b;
        line-height: 17px;

        .card-head {
          display: flex;
          align-items: center;
          padding: 0 16px;
          color: #fff;
          height: 52px;
          font-size: 18px;
          background: #102345;
          border-radius: 15px 15px 0px 0px;
        }
        .noAnswer {
          width: 6px;
          height: 6px;
          border: 1px solid #9b9b9b;
          border-radius: 4px;
        }
        .isAnswer {
          width: 6px;
          height: 6px;
          background: #1fa3ff;
          border-radius: 4px;
        }
        .card-title {
          height: 42px;
          border-bottom: 1px solid #e1e1e1;
          .title-item {
            display: inline-flex;
            align-items: center;
            margin-right: 18px;
          }
        }
        .question-modal {
          padding: 8px 0;
          width: 100%;
          .modal-title {
            display: flex;
            margin-bottom: 6px;
            align-items: center;
            width: 100%;
            height: 30px;
            padding: 0 18px;
            font-size: 16px;
            font-weight: 700;
            text-align: left;
            color: #000000;
            line-height: 20px;
          }
          .tips {
            margin-left: 10px;
            font-size: 12px;
            font-weight: 400;
            text-align: right;
            color: #9b9b9b;
            line-height: 17px;
          }
          .modal-content {
            display: flex;
            justify-content: flex-start;
            flex-wrap: wrap;
            padding: 0 13px;

            .compose-item {
              color: #000;
              display: flex;
              align-items: center;
              justify-content: center;
              width: 10%;
              // max-width: 38px;
              min-width: 36px;
              position: relative;
              .corner {
                position: absolute;
                right: -5px;
                width: 0px;
                height: 0px;
                top: -5px;
                border: 4px solid #797979;
                border-bottom-color: transparent;
                border-top-color: transparent;
                border-left-color: transparent;
                transform: rotateZ(135deg);
              }
              .item-content {
                position: relative;
                border: 1px solid #e5e5e5;
                margin: 6px 0;
                padding: 3px;
                display: flex;
                align-items: center;
                justify-content: center;
                width: 24px;
                height: 24px;
                box-sizing: border-box;
                .item-centre {
                  width: 18px;
                  height: 18px;
                  font-size: 12px;
                  font-weight: 400;
                  text-align: center;
                  color: #4a4a4a;
                  line-height: 17px;
                }
              }
              &.finish {
                .corner {
                  position: absolute;
                  right: -5px;
                  width: 0px;
                  height: 0px;
                  top: -5px;
                  border: 4px solid #44d7b6;
                  border-bottom-color: transparent;
                  border-top-color: transparent;
                  border-left-color: transparent;
                  transform: rotateZ(135deg);
                }
                .item-content {
                  position: relative;
                  border: 1px solid #e5e5e5;
                  color: #fff;
                  .item-centre {
                    color: #fff;

                    background: #44d7b6;
                    display: flex;
                    align-items: center;
                    justify-content: center;
                    width: 100%;
                    height: 100%;
                  }
                }
              }
            }
            .question-item {
              color: #000;
              display: flex;
              align-items: center;
              justify-content: center;
              width: 10%;
              // max-width: 38px;
              min-width: 36px;
              position: relative;
              .corner {
                position: absolute;
                right: -5px;
                width: 0px;
                height: 0px;
                top: -5px;
                border: 4px solid #797979;
                border-bottom-color: transparent;
                border-top-color: transparent;
                border-left-color: transparent;
                transform: rotateZ(135deg);
              }
              .item-content {
                position: relative;
                border: 1px solid #e5e5e5;
                margin: 6px 0;
                padding: 3px;
                display: flex;
                align-items: center;
                justify-content: center;
                width: 24px;
                height: 24px;
                box-sizing: border-box;
                .item-centre {
                  width: 18px;
                  height: 18px;
                  font-size: 12px;
                  font-weight: 400;
                  text-align: center;
                  color: #4a4a4a;
                  line-height: 17px;
                }
              }
              &.finish {
                .corner {
                  position: absolute;
                  right: -5px;
                  width: 0px;
                  height: 0px;
                  top: -5px;
                  border: 4px solid #1fa3ff;
                  border-bottom-color: transparent;
                  border-top-color: transparent;
                  border-left-color: transparent;
                  transform: rotateZ(135deg);
                }
                .item-content {
                  position: relative;
                  border: 1px solid #e5e5e5;
                  color: #fff;
                  .item-centre {
                    color: #fff;

                    background: #1fa3ff;
                    display: flex;
                    align-items: center;
                    justify-content: center;
                    width: 100%;
                    height: 100%;
                  }
                }
              }
            }
          }
        }
      }
      .btn-submit {
        width: 387px;
        height: 50px;
        cursor: pointer;
        background: #1fa3ff;
        border-radius: 26px;
        margin-top: 26px;
        font-size: 16px;
        font-weight: 500;
        text-align: left;
        color: #ffffff;
        line-height: 34px;
        display: flex;
        align-items: center;
        justify-content: center;
      }
    }
  }
  .submit-modal {
    z-index: 9999;
    position: relative;
    width: 506px !important;
    height: 308px;
    background: #ffffff;
    border-radius: 13px;
    box-shadow: 0px 2px 29px 16px rgba(0, 0, 0, 0.03);
    .icon-left {
      // margin: 20px;
      // margin-left: 0;
      position: absolute;
      // width: 60px;
      width: 80px;
      top: 60px;
      left: 60px;
      // margin-left: 40px;
      // margin-top: 5px;
      object-fit: contain;
    }
    .icon-right {
      position: absolute;
      // width: 60px;
      width: 80px;
      right: 30px;
      top: 100px;
      object-fit: contain;
    }
    .title {
      width: 100%;
      font-size: 24px;
      font-weight: 600;
      text-align: center;
      color: #161616;
      line-height: 33px;
      letter-spacing: 1px;
    }
    .tips {
      width: 100%;
      font-size: 12px;
      font-weight: 400;
      text-align: center;
      color: #999999;
      line-height: 25px;
      letter-spacing: 0px;
    }
    .score {
      font-size: 70px;
      font-weight: 500;
      text-align: center;
      color: #ff6c75;
      line-height: 94px;
    }
    .submit-btn {
      width: 204px;
      height: 37px;
      background: #1fa3ff;
      border-radius: 26px;
      font-size: 16px;
      font-weight: 500;
      text-align: left;
      color: #ffffff;
      line-height: 34px;
      display: flex;
      align-items: center;
      justify-content: center;
      margin: 26px auto;
    }
  }
}
</style>                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                